import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  useDispatch,
  useSelector,
} from 'react-redux';

import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Tabs from 'antd/lib/tabs';
import notification from 'antd/lib/notification';
import Button from 'antd/lib/button';
import Affix from 'antd/lib/affix';
import Tooltip from 'antd/lib/tooltip';
import Input from 'antd/lib/input';
import Switch from 'antd/lib/switch';
import Divider from 'antd/lib/divider';
import Menu from 'antd/lib/menu';
import Popover from 'antd/lib/popover';

import { useCtx } from 'one-ui-provider';

import {
  Sider,
  Header,
  Footer,
  Layout,
  Content,
  ContentBox,
} from 'one-ui-layout';

import {
  HeaderBar, TopNavigation, NavigationItem,
  UserNavigation, UserNavigationItem,
  FooterBox, FooterAsideItem
} from 'one-ui-header';

import {
  AddNewFormEnable,
  SourceCardSimple
} from 'one-card-source';

import {
  CallDestinationCard
} from 'one-card-call-destination';

import {
  SubjectCard
} from 'one-card-subject';

import logo from "./logo.png";

import {
  UpcomingAppointmentCard,
} from 'one-card-upcoming-appointments';

import {
  AlertsCard,
  AlertsSummaryCard
} from '../../../_local/one-card-alerts';
import {
  PendingBillsCard
} from 'one-card-pending-bills';
import {
  PendingBillsCardCerner
} from 'one-card-pendingbills-cerner';
import {
  PendingBillsCardAthena
} from 'one-card-pending-bills-athena';

import {
  PendingReferalsCard,
  ReferralsTab
} from 'one-card-pending-referrals';

import {
  PatientCareProviderCard,PatientCareProviderCardEHR
} from 'one-card-pcp';

import {
  Notification as NotifyCard
} from 'one-card-notification';

import {
  PatientAdditionalInfoCard
} from 'one-card-patient-additional-info';

import {
  EmergencyContactCard
} from 'one-card-emergency-contact'

import {
  setSelectedAction,
  addAction as addSubjectAction,setSelectedCernerAction,
  setSelectedAthenaAction,setSelectedMeditechAction,setSelectedNextgenAction,setSelectedECWAction,
  setPatientSelectedAction
} from 'one-state-subject/src/actions';

import {
  EmploymentInfoCard,
  EmploymentInfoCardAthena
} from 'one-card-employment-info'

import {
  PharmaciesCard
} from "one-card-patient-pharmacy";

import {
  selectAction,
  addAction as addSourceAction,
  removeAction
} from 'one-state-source-local';

import {
  setAction as setTabAction
} from 'one-state-tabs';

import {
  ScreenPopFrom,
  ScreenpopModel
} from 'one-state-screenpop/src/model';

import {
  setAction as screenpopAction
} from 'one-state-screenpop/src/actions';

import {
  ScreenpopModel as ReceiveCommModel
} from 'one-state-receive-communication/src/model';

import {
  setAction as ReceiveCommAction
} from 'one-state-receive-communication/src/actions';

import {
  setAction as addNewFormAction
} from 'one-state-addnew';
import { Desktop } from "@wxcc-desktop/sdk";
import {
  setAction as setSourceType,
  selectAction as selectSourceType,
} from 'one-state-source-type';

import {
  SourceType,
  Skeleton,
  Disposition
} from 'one-model-local';

import {
  ScreenpopComp, HotButtons, DrawerComp,PanvivaComp, HotButtonsFive9, UpdatePVvalue
} from 'one-card-drawer';

import {
  MapCard
} from 'one-card-leafletmap';

import {
  AppointmentCard,
  AppointmentCardAthena,
  AppointmentCardNextgen,
  AppointmentCardCerner
  } from 'one-card-appointments-table';

import {
  addAction as addAppointmentType
} from 'one-state-appointments';
import {
  ActiveAlleriesCard
} from 'one-card-activeallergies';

import {
  ActiveProblemsCard
} from 'one-card-activeproblems';


import {
  MedicalHistoryCard
} from 'one-card-medicalhistory';

import {
  ProviderMatch, NoCall
} from 'one-comp-newcall';
import {
  PatientVerify, NoMatchCall
} from 'one-comp-verifynewpatient';

import {
  OrderTabCard
} from 'one-comp-orderstab'

import {
  ErrorHandlingCard
} from 'one-comp-errorhandling'

import {
  NotesHistoryCard
} from 'one-card-notes-history';

import SearchIco from 'one-ui-svg/svg/search.svg';
import NoteIco from 'one-ui-svg/svg/note.svg';
import AgentIco from 'one-ui-svg/svg/agent.svg';
import arrowRight from 'one-ui-svg/svg/arrow-right.svg';
import { Image_URL } from 'one-ui-image';

import {
  setAction as globalSearchAction,
  reinitAction as reinitPatientSearchAction
} from 'one-state-patient-global-search';

import {
  reinitAction as reinitProviderSearchAction
} from 'one-state-provider-global-search';

import {
  PatientGlobalSearchCard
} from 'one-comp-patient-global-search';

import { NewVerifyFlow } from 'one-card-verifyflow';

import {
  setAction as setSkeletonAction
} from 'one-state-skeleton';

import {
  BillingCard
} from 'one-comp-billing-details';
import {
  BillingCardCerner} from 'one-comp-billing-details-cerner';
import {
    BillingCardAthena} from 'one-comp-billing-details-athena';
import {
  selectAction as selectBillingAction,
  setBillingPaymentAction,
} from 'one-state-billing-details';
import {
  InsuranceCard,
  InsuranceCardAthena
} from 'one-card-insurance';


import { PrescriptionTab, PrescriptionEHRTab } from 'one-card-prescription';

import {
  MedicationCard
} from 'one-comp-medication';
import {
  Version,
  CallSelection
} from 'one-simulator';
import { adjustHeightWithParams } from 'one-gadget-loader';


import {
  UserIdCard
} from 'one-comp-epicuserid';

import {
  NewUserIdModalCard
} from 'one-comp-newusermodal'


import { 
  PatientMatchType, 
  PatientMatchFrom,
  setMatchTypeAction as setPatientMatchTypeAction, 
  setMatchFromAction as setPatientMatchFromAction
} from 'one-state-patient-match';

import ClearTriage from './cleartriage';

import {
  ServiceNowCallerCard
} from 'one-card-sncallermodal';

import {
  CallRecord
} from 'one-comp-callrecord'

import {
  IncidentsCard
} from 'one-comp-incidents';

import {
  InteractionsCard,
} from 'one-comp-interactions';

import { UserTimeline } from 'one-comp-user-timeline';
import { CallHistoryTab } from 'one-card-call-history';
import {
  PanvivaIdCard
  } from 'one-comp-panvivaid'

  import {
    setAction as panvivaAction
  } from 'one-state-panviva/src/actions';
  import {
    PanvivaModel
  } from 'one-state-panviva/src/model';


let queryString = require('query-string');

const { TextArea } = Input;
/**
 * Main application UI component
 * @param props - component properties
 */
export const App = (props: any) => {
  const upappts = useSelector((state: any) => (state.upappointments));
  const pendingb = useSelector((state: any) => (state.pendingbill));
  const pendingbillscerner = useSelector((state: any) => (state.pendingbillscerner));
  const patients = useSelector((state: any) => (state.subjectstore));
  const entity = useSelector((state: any) => (state.calledentity));
  const referrals = useSelector((state: any) => (state.pendingreferals));
  const source = useSelector((state: any) => (state.sources));
  const sourceType = useSelector((state: any) => (state.sourcetype));
  const pcpstate = useSelector((state: any) => (state.pcpstate));
  const pharmacies = useSelector((state: any) => (state.pharmacy))
  const activetab = useSelector((state: any) => (state.activetab));
  const screenpopstate = useSelector((state: any) => (state.screenpopstate));
  const receivecommunication = useSelector((state: any) => (state.receivecommunicationstate));
  const addnew = useSelector((state: any) => (state.addnew));
  const apptstable = useSelector((state: any) => (state.appointments));
  const allergiesstate = useSelector((state: any) => (state.allergiesstate));
  const activeproblems = useSelector((state: any) => (state.activeproblems));
  const medicalhistory = useSelector((state: any) => (state.medicalhistory));
  const patientglobalsearch = useSelector((state: any) => (state.patientglobalsearch));
  const verify = useSelector((state: any) => (state.patientverify));
  const providerglobalsearch = useSelector((state: any) => (state.providerglobalsearch));
  const errorstate = useSelector((state: any) => (state.errorstate));
  const skeleton = useSelector((state: any) => (state.skeleton));
  const choosecaller = useSelector((state: any) => (state.choosecaller));
  const prescription = useSelector((state: any) => (state.prescription));
  const medication = useSelector((state: any) => (state.medicationdata));
  const orderstabdata = useSelector((state: any) => (state.orderstabledata))
  //const patientdrawer = useSelector((state: any) => (state.patientdrawer));
  const billingdetails = useSelector((state: any) => (state.billingdetails));
  const billingdetailscerner = useSelector((state: any) => (state.billingdetailscerner));
  const billingdetailsathena=useSelector((state: any) => (state.billingdetailsathena));
  const insurancedetails = useSelector((state: any) => (state.insurancedetails));
  const monitor = useSelector((state: any) => (state.errormonitor));
  const five9InteractionId = useSelector((state: any) => (state.five9Interaction));
  const vonageInteractionId = useSelector((state: any) => (state.vonageInteraction));
  const ccpConnectionData = useSelector((state: any) => (state.ccpInteraction));
  const { active: hasGadgetCall } = useSelector((state: any) => (state.hotkeys));
  const five9Store = useSelector((state: any) => (state.five9Store));
  const five9ClickToDial = useSelector((state: any) => (state.five9ClickToDial));
  const fhirdata = useSelector((state:any) => (state.fhirdetails));
  const epicuserid = useSelector((state:any) => (state.epicuserid));
  const updateuserdata = useSelector((state:any) => (state.updateuserdata))
  const sourcesearchstate = useSelector((state: any) => (state.sourcesearchdata));
  const servicenowinfo = useSelector((state:any) => (state.servicenowcaller));
  const incidentsinfo = useSelector((state:any)=> (state.getincidents));
  const interactionsinfo = useSelector((state:any)=> (state.getinteractions));
  const createinteractionsdata = useSelector((state:any)=> (state.createinteraction));
  const createincidentsdata = useSelector((state:any)=> (state.createincident));
  const updateincidentsdata = useSelector((state:any) => (state.updateincidentstate))
  const linkedincidentdata = useSelector((state:any)=> (state.linkedincident))
  const btgpatientdata = useSelector((state: any) => (state.bgtpatient));
  const patienterror  = useSelector((state:any)=> (state.patientlookuperror));
  const patientMatch = useSelector((state:any)=> (state.patientMatch));
  const setsession = useSelector((state:any)=>(state.setsessionreducer));
  const getsessionresp = useSelector((state:any)=>(state.getsessionreducer));
  const subjectdemo = useSelector((state:any)=>(state.selectedsubjectinfo));
  const { subjectId: five9_subject_id, sourceId: five9_source_id } = useSelector((state: any) => (
    state.five9CallVariables
  ));
  const { interactionId } = useSelector((state: any) => (
    state.five9Interaction
  ));
  const userstate = useSelector((state: any) => (state.userstate));
  const dispositionstate = useSelector((state: any) => (state.dispositionstate));
  const five9LogoutCodes = useSelector((state: any) => (state.five9LogoutCodes));
  const five9UserState = useSelector((state: any) => (state.five9UserState));
  const wxccInteraction = useSelector((state: any) => (state.wxccInteraction));
  const genesysinteraction = useSelector((state:any)=> (state.interactioninfo))
  const genesysagentdata = useSelector((state:any)=> (state.genesysagentinfo));
  const callHistory = useSelector((state: any) => (state.callHistory));
  const notesHistory = useSelector((state: any) => (state.notesHistory));
  const panvivauser = useSelector((state:any)=> (state.panvivauser));
  const panvivasearch = useSelector((state:any)=> (state.panvivasearch));
  const updatepanvivauserdata = useSelector((state:any) => (state.updatepanvivadata))
  const alertnextgen=useSelector((state:any)=>(state.alertdata))
  const { TabPane } = Tabs;
  const dispatch = useDispatch();
  const { agentId,agentLoginName, teamName, settings, resolver, alertnotification, interactionApi, log, static_resource_url } = useCtx();



  let { athenaendpoints,cernerendpoints, epicendpoints, ehr,ehr: {epic, athena,cerner,meditech,nextgen},compatible,updatepv, screenpop, hotkeys, screenpop_config, uisettings: {epicuserid_note,updateappointment, confirmappointment,rescheduleappointment, dashboardtab, dashboardapiconfig,panviva_config, dashboardcardconfig, queryparameter, autoscreenpop,autoscreenpop_default_context,five9_sso_url,five9_url, simulator, version, tabconfig,btg_config:{btgenable,btgmessage}, sider, drawer, search, card_screenpop_config: { screenpop_config_subjectcard }, uniphore }, soucetypelookup, auth, five9_callvariables, toaster_notification } = settings;
 let {epic_id_format}=epicuserid_note
  const {searchID} = epicendpoints;
  const { map: screenpopmap } = screenpop;
  const { map: hotbtnmap} = hotkeys;
  const {hotlinks, panviva_user,panviva_wordsearch} = panviva_config;
  const { patientappointment, getpendingreferrals, getbillingdetails, insurance, activeproblems: activeproblemsCard, medicalhistory: medicalhistoryCard, activeallergies } = dashboardapiconfig;
  const {
    appointments,
    pendingReferrals,
    billingInformation,
    patientCareTeam,
    emergencyContact,
    employmentInformation,
    pharmacies: pharmacyCard,
    insuranceDetails,
    timeline
  } = dashboardcardconfig;
  const { location, apptdesk, referraldesk, pendingbills,refilldesk,pharmacy, nomatchid, event,patientchart } = screenpop_config;

  const ccQueryParams = queryString.parse(window.location.search);
  const validCCTypes = ['finesse','five9','vonage','inContact','twilio','ringcentral','genesys','wxcc','intermedia','glia'];
  const validScreenpopTypes = ['snap_adapter','receive_communication','receive_communication02','receive_communication03','web_screenpop'];
  if (ccQueryParams.cc_type && validCCTypes.includes(ccQueryParams.cc_type as string)) {
    compatible.contact_center_type = ccQueryParams.cc_type as string;
  }
  if (ccQueryParams.screenpop_type && validScreenpopTypes.includes(ccQueryParams.screenpop_type as string)) {
    compatible.screenpop_type = ccQueryParams.screenpop_type as string;
  }

const { contact_center_type, finesse_gadget_height, utility_menu_width, utility_note_display, agenta_dashboard_icon,screenpop_type,useridtype,  consolidated_api_invocation, sso, panviva_sso, lookuptype, five9_Adapter_width, five9_Adapter_height,display_logout_button,silentgadget, websocket_url, wxcc_entrypoint_id, outbound_silentgadget,clicktocall } = compatible  
  let intermedia_callvariables: any = {};
  if(contact_center_type==="intermedia"){
    intermedia_callvariables = settings.intermedia_callvariables || {};
  }
  const {agentid_url_sessions, agentid_url_session, token_intermedia, intermedia_agentId} = intermedia_callvariables;
  const { kill_all_notification } = toaster_notification;
  const [quickdrawer, setQuickDrawer] = useState(false);
  const [activeallergy, setActiveAllergy] = useState(null);
  const [activeproblem, setActiveProblem] = useState(null);
  const [five9logout, setFive9Logout] = useState(five9Store?.globalsearch);
  const monitorvalue = monitor?.monitor;
  const [widget, setWidget] = useState(true);
  const [tabs, setTabs] = useState("1");
  const [globalpatientselected,setGlobalPatientSelected] = useState<any>({});
  //params hooks for twilio
  const [paramTwilioSid,setParamTwilioSid]=useState("");
  const [paramTwilioAni,setParamTwilioAni]=useState("");
  const [paramTwilioDni,setParamTwilioDni]=useState("");
  const [paramTwilioAgentName,setParamTwilioAgentName]=useState("");
  const [paramTwilioehr,setParamTwilioehr]=useState({epic:epic,athena:athena,cerner:cerner})

   //params hooks for inCOntact
   const [paramInContactSid,setParamInContactSid]=useState("");
   const [paramInContactAni,setParamInContactAni]=useState("");
   const [paramInContactDni,setParamInContactDni]=useState("");
   const [paramInContactAgentName,setParamInContactAgentName]=useState("");
   const [paramInContactAgentID,setParamInContactAgentID]=useState("");
   const [paramInContactSkillName,setParamInContactSkillName]=useState("");
   const [paramInContactEpicExternalID,setParamInContactEpicExternalID]=useState("");
   const [shouldFetchUserId, setShouldFetchUserId] = useState(false);


   const ringcentralCalldata=useSelector((state:any)=>(state.ringCentralCallData));
   const ringcentrallogin=useSelector((state:any)=>(state.ringCentralLogin))
   const [ringlogin,setRingLog]=useState(false);

    const [tokengen,setTokengen]=useState(null)
    const [tokenstat,setTokenstat]=useState("")
      ///intermedia token

    const [intermediasearch,setIntermediasearch]=useState(false)
    const [inContactsearch, setInContactsearch] = useState(false)

    //params hooks for intermedia
    const [paramIntermediaSid,setParamIntermediaSid]=useState("");
    const [paramIntermediaAni,setParamIntermediaAni]=useState("");
    const [paramIntermediaDni,setParamIntermediaDni]=useState("");
  const  vonage_userId=useSelector((state:any)=>(state.vonageAgentId?.agentId))
  //global search hide fore vonage before agent login
  const vonageGlobalSearch=useSelector((state:any)=>state.vonageUserState?.userStates)
  const { actions } = useSelector((state: any) => (
    state.hotkeys
  ));
  let callType = sessionStorage.getItem("callType")
  let screenpopcounter = Object.keys(receivecommunication).length.toString();
  sessionStorage.setItem("screenpopcounter",screenpopcounter)

  const global_search =()=>{
dispatch(globalSearchAction(true));
  }

  const getSubstrings=(inputString:string)=>{
    // Early return for empty or undefined input
    if (!inputString) {
      return [];  // Return empty array for invalid input
    }
  
    try {
      const regex = /[_-]/;  // Match underscore or hyphen
      const substrings = inputString.split(regex);
      return substrings;
    } catch (error) {
      console.error("Error splitting string:", error);
      return [];  // Return empty array on error
    }
  }

  let wss: any = null;
  let wxccInteractionId: any = null;

  useEffect(()=>{
    sessionStorage.removeItem("agentepicuserid")
    
    if(epicuserid?.agentuserid && (contact_center_type === "wxcc" || contact_center_type === "five9") && clicktocall) {
      socketConnect();
    } 
    return () => {
      wss?.close();
  };
  },[epicuserid])

  const socketConnect = () => {
    wss = new WebSocket(websocket_url);
    wss.onopen = onOpenHandler;
    wss.onerror = onErrorHandler;
    wss.onmessage = onMessageHandler;
    wss.onclose = onCloseHandler;
};

const onOpenHandler = (event: any) => {
  console.log("WebSocket is connected!");

  if(wss && wss.readyState === WebSocket.OPEN) {

    const agentName = sessionStorage.getItem("agentName")

    const regEpicUser = {"EpicUserID": agentName}

     wss.send(JSON.stringify(regEpicUser));

    setInterval(() => {
      const message = {
        type: "ping"
      };
  
      console.log("Sending PING on socket");
      
      try {
        const jsonMessage = JSON.stringify(message);
        wss.send(jsonMessage);
      } catch (ex) {
        console.log("Failed sending ping");
      }

    }, 30000)
  }
};

const onCloseHandler = (event: any) => {
  console.log('socket disconnected: ', event);
  setTimeout(socketConnect, 5000); //call check function after timeout
};


const onMessageHandler =  async (event: any) => {

  console.log("Message receieved from server: ", event.data);

  var data = JSON.parse(event.data);
  let interactionId = sessionStorage.getItem("CallInteractionId")

  if(data?.PhoneNumber && data?.requestType == "INITIATE" && contact_center_type === "wxcc") {
    try {
      let ani = choosecaller?.ani
      const outDial = await Desktop.dialer.startOutdial({
        data: {
          destination: data.PhoneNumber,
          direction: "OUTBOUND",
          entryPointId: wxcc_entrypoint_id,
          attributes: {},
          mediaType: "telephony",
          outboundType: "OUTDIAL",
        },
      });

      wxccInteractionId = outDial?.data?.interactionId || null;

      console.log("Received interaction Id: ", wxccInteractionId);

      if(wss && wss.readyState === WebSocket.OPEN) {

        console.log("Sending interaction ID to Server");
        wss.send(JSON.stringify({Status: "INITIATED", CallID: wxccInteractionId}));

      }

      console.log("OutDial Call Success", JSON.stringify(outDial));
    } catch (error) {
      console.error("OutDial Call Failed", error);
      if(wss && wss.readyState === WebSocket.OPEN) {

        console.log("Sending interaction ID to Server");
        wss.send(JSON.stringify({Status: "FAILED_TO_INITIATE",CallID: null}));

      }
    }
  }
  else if(data?.requestType == "END" && data?.PhoneAgentID && contact_center_type === "wxcc") {

    try{

      const endCall = await Desktop.agentContact.end({
        interactionId: wxccInteractionId
      });

      console.log("End call response: ", endCall);

      if(wss && wss.readyState === WebSocket.OPEN) {
        console.log("Sending call ended status to Server");
        wss.send(JSON.stringify({Status: "ENDED"}))
      }
    }
    catch (error) {
      console.log("Hang up call Failed: ", error);
      if(wss && wss.readyState === WebSocket.OPEN) {
        console.log("Sending call ended status to Server");
        wss.send(JSON.stringify({Status: "FAILED_TO_END"}))
      }
    }

  }
  else  if(data?.PhoneNumber && data?.requestType == "INITIATE" && contact_center_type === "five9") {
    console.log("-Entered the initiate condition")
    try {
      var crmApi = window.Five9.CrmSdk.crmApi();
      let clickToDialNumber = data.PhoneNumber.replace(/[^a-zA-Z0-9]/g, '');
      crmApi.click2dial({click2DialData: { clickToDialNumber }, screenpopC2DSearch: true})


      if(wss && wss.readyState === WebSocket.OPEN) {
        console.log("Sending interaction ID to Server");
        wss.send(JSON.stringify({Status: "INITIATED", CallID: interactionId}));

      }
    } catch (error) {
      console.error("OutDial Call Failed", error);
      if(wss && wss.readyState === WebSocket.OPEN) {

        console.log("Sending interaction ID to Server");
        wss.send(JSON.stringify({Status: "FAILED_TO_INITIATE",CallID: null}));

      }
    }
  }
  else if(data?.requestType == "END" && data?.PhoneAgentID && contact_center_type === "five9") {

    try{

      var interactionApi = window.Five9.CrmSdk.interactionApi();
      let agentIdValue = sessionStorage.getItem("five9_agentId")
      var crmApi = window.Five9.CrmSdk.crmApi();
      interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${agentIdValue}/interactions/calls/${interactionId}/disconnect`, method: 'PUT' }).then(function (result: any) {
        // resolve handler
        const { response } = result
        const data = JSON.parse(response.replace('/', ''))
        console.log("End call response: ",data);
    }, function (error: any) {
        // reject handler
        console.debug('Auth metadata error ', error);
    });



      if(wss && wss.readyState === WebSocket.OPEN) {
        console.log("Sending call ended status to Server");
        wss.send(JSON.stringify({Status: "ENDED"}))
      }
    }
    catch (error) {
      console.log("Hang up call Failed: ", error);
      if(wss && wss.readyState === WebSocket.OPEN) {
        console.log("Sending call ended status to Server");
        wss.send(JSON.stringify({Status: "FAILED_TO_END"}))
      }
    }
  }
};

const onErrorHandler = (e: any) => {
  console.log('socket error: ', e);
  wss?.close();
};


  useEffect(()=>{
    if(setsession?.length > 0 ) {
      sessionStorage.setItem("finesse_uid",setsession[0]?.created_key)
      if(contact_center_type === "finesse") {
        ((updatepv?.sessionkey) && (updatepv?.sessionkey!= "")) && (UpdatePVvalue('sessionkey', setsession[0].created_key, actions, settings, log));
      }
      else if (contact_center_type === "five9") {
        if (contact_center_type && contact_center_type === 'five9') {
          let interactionApi = window.Five9.CrmSdk.interactionApi();
          interactionApi.getCav({interactionId}).then(function (cavList: any) {
            console.log('IframeV4 got cavList: ' + JSON.stringify(cavList));
            let five9sourceid = sessionStorage.getItem("five9_source_id");
            interactionApi.setCav(
              {
                interactionId,
                cavList: [{id: five9_source_id ? five9_source_id : five9sourceid, name: "sourceid", group: "Caller", type: "STRING", value: setsession[0].created_key}]
              }).then(function (response: any) {
                console.log({setSourceIdCavResponse: response});
                interactionApi.getCav({interactionId}).then(function (cavList: any) {
                  console.log('IframeV5 got cavList: ' + JSON.stringify(cavList));
                })
                //Dispostion Implementation
                let disp: Disposition = { value: "172" }
                disp.dial_list_uid = interactionId;
                let agentIdValue = sessionStorage.getItem("agentName");
                disp.meta00 = agentIdValue;
                disp.meta01 = teamName;
                disp.meta02 = five9_source_id ? five9_source_id : five9sourceid;
                disp.meta03 = setsession[0]?.created_key;
                disp.meta04 = 'client';
                dispatch({
                  type: "store-disposition-code",
                  payload: disp
                })
              })
          })
        }
      }
    }
  },[setsession,patients.selected,source.selected])

  const setEHRProvider = () => {
    const validEhrValues = ['epic', 'athena', 'nextgen', 'cerner', 'meditech', 'ecw'];
    const searchparameter = queryString.parse(window.location.search);
    const ehrValueParam = searchparameter?.ehr_value as string;

    if (ehrValueParam && validEhrValues.includes(ehrValueParam.toLowerCase())) {
      sessionStorage.setItem('ehr', ehrValueParam.toLowerCase());
    } else if (ehr) {
      const activeEhr = Object.keys(ehr).find(key => ehr[key] === true);
      sessionStorage.setItem('ehr', activeEhr || 'epic');
    } else {
      sessionStorage.setItem('ehr', 'epic');
    }
  };

  const getEHRProvider = () => {
    return sessionStorage.getItem('ehr');
  };

  useEffect(() => {
    const sourceTypeSession: SourceType[] = soucetypelookup;
    setEHRProvider();

    let agentIdValue = agentId;
      //To check for the contact center type and update the  agentIDValue
        if (contact_center_type && contact_center_type === 'five9') {
          //This is for Five9
          agentIdValue = sessionStorage.getItem("five9_userid");
        }
        else if (contact_center_type && contact_center_type === 'vonage' ) {
          //This is for Vonage
          agentIdValue = sessionStorage.getItem("vonage_userid")
        }
        else if (contact_center_type && contact_center_type === 'inContact' ) {
          //This is for Vonage
          agentIdValue = sessionStorage.getItem("NiceEpicUserID")
        }
        else if (contact_center_type && contact_center_type === 'twilio' ) {
          //This is for Twilio
          agentIdValue = sessionStorage.getItem("twilio_userid")
        }
        else if (contact_center_type && contact_center_type === 'ringcentral' ) {
          //This is for ringcentral
          agentIdValue = sessionStorage.getItem("ringcentral_agentName")
        }
        else if(contact_center_type === "genesys") {
          let genesys_userid =sessionStorage.getItem("agentName")
          //This is for Genesys
          agentIdValue = genesys_userid
        }
        else if (contact_center_type && contact_center_type === 'wxcc' ) {
          //This is for Vonage
          agentIdValue = epicuserid?.agentuserid;
        }
        else if (contact_center_type && contact_center_type === 'intermedia' ) {
          //This is for Intermedia
          agentIdValue = sessionStorage.getItem("intermedia_userid")
        }
        // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
        if (sso === false ) {
          agentIdValue = epicuserid?.agentuserid;
        }

    let actionType = '';
    switch (getEHRProvider()) {
      case 'epic':
        actionType = 'caller-patient';
        break;
      case 'athena':
        actionType = 'caller-patient-athena';
        break;
      case 'cerner':
        actionType = 'caller-patient-cerner';
        break;
      case 'meditech':
          actionType = 'caller-patient-meditech';
          break;
      case 'nextgen':
          actionType = 'caller-patient-nextgen';
          break;
      case 'ecw':
            actionType = 'caller-patient-ecw';
            break;
    }

    if (getsessionresp?.length > 0) {
      if (getsessionresp[0]?.lookup_response?.length > 0) {
        let payload={}
        if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& (contact_center_type==='intermedia' || contact_center_type==='inContact')){
          payload={
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            subjectid: getsessionresp[0].subjectID,
            token:tokenstat,
            tokenstr: tokengen
          }
        }
        else{
          payload={
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            subjectid: getsessionresp[0].subjectID,
          }
        }
        dispatch({
          type: actionType,
          payload: payload
        });
        if(getEHRProvider()==="epic"){
          dispatch({
            type: "one-state-btgpatient/fetch",
            payload: {
              identifier: getsessionresp[0].subjectID
            }
          })
        }
       
        // for source
        if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& (contact_center_type==='intermedia' || contact_center_type==='inContact')){

        dispatch({
          type: actionType,
          payload: {
            sourceid: getsessionresp[0].sourceID,
            token:tokenstat,
            tokenstr: tokengen
          }
        })
      }
      else{
        dispatch({
          type: actionType,
          payload: {
            sourceid: getsessionresp[0].sourceID
          }
        })
      }
       dispatch({
      type: 'one-state-patient-verified/set',
      payload: {
        verified: true,
      },
    });
      if(getEHRProvider() === 'epic'){
        setTimeout(()=>{
          dispatch({
            type: "one-state-btgpatient/fetch",
            payload: {
              identifier: getsessionresp[0].sourceID
            }
          })
        },2000)
      }
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            visible: false
          }
        });

        //Dispostion for call controls
        let disp: Disposition = { value: "193" }
        let agentId="";
        let teamName="";
        let callType="";
        disp.meta02 = getsessionresp[0].subjectID;
        disp.meta03 = getsessionresp[0].sourceID;
        disp.meta04 = setsession[0].created_key;
        if(contact_center_type==="finesse"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = agentId;
          disp.meta01 = teamName;
          disp.meta05 = callType;
        }
        else if(contact_center_type==="five9"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("agentName");
          disp.meta01 = sessionStorage.getItem("skillName");
          disp.meta05 = callType;
        }
        else if(contact_center_type==="genesys"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("name");
          disp.meta01 = sessionStorage.getItem("agentName");
          disp.meta05 = callType;
        }
        else if(contact_center_type==="twilio"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = paramTwilioAgentName;
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="ringcentral"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="inContact"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = paramInContactAgentName;
          disp.meta01 = paramInContactSkillName;
          disp.meta05 = callType;
        }
        else if(contact_center_type==="vonage"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("vonage_userid");
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="wxcc"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("wxcc_agentId");
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="intermedia"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = paramIntermediaAni;
          disp.meta01 = paramIntermediaDni;
          disp.meta05 = callType;
        }
        dispatch({
          type: "store-disposition-code",
          payload: disp
        });
      }
      else if (getsessionresp[0]?.subjectID?.length > 0) {
        dispatch({
          type: actionType,
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            subjectid: getsessionresp[0].subjectID,
          }
        });
        dispatch({
          type: 'one-state-patient-verified/set',
          payload: {
            verified: true,
          },
        });
        // for source
        dispatch({
          type: actionType,
          payload: {
            sourceid: getsessionresp[0].sourceID
          }
        })

        if(!btgenable && getEHRProvider()==='epic'){
          dispatch({
            type: "one-state-btgpatient/fetch",
            payload: {
              identifier: getsessionresp[0].subjectID
            }
          })
  
          setTimeout(()=>{
            dispatch({
              type: "one-state-btgpatient/fetch",
              payload: {
                identifier: getsessionresp[0].sourceID
              }
            })
          },2000)
        }
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            visible: false
          }
        });

        //Dispostion for call controls
        let disp: Disposition = { value: "193" }
        let agentId="";
        let teamName="";
        let callType="";
        disp.meta02 = getsessionresp[0].subjectID;
        disp.meta03 = getsessionresp[0]?.sourceID;
        disp.meta04 = setsession[0]?.created_key;
        if(contact_center_type==="finesse"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = agentId;
          disp.meta01 = teamName;
          disp.meta05 = callType;
        }
        else if(contact_center_type==="five9"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("agentName");
          disp.meta01 = sessionStorage.getItem("skillName");
          disp.meta05 = callType;
        }
        else if(contact_center_type==="genesys"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("name");
          disp.meta01 = sessionStorage.getItem("agentName");
          disp.meta05 = callType;
        }
        else if(contact_center_type==="twilio"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = paramTwilioAgentName;
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="ringcentral"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="inContact"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = paramInContactAgentName;
          disp.meta01 = paramInContactSkillName;
          disp.meta05 = callType;
        }
        else if(contact_center_type==="vonage"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("vonage_userid");
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="wxcc"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = sessionStorage.getItem("wxcc_agentId");
          disp.meta01 = "";
          disp.meta05 = callType;
        }
        else if(contact_center_type==="intermedia"){
          disp.dial_list_uid = choosecaller?.callId;
          disp.meta00 = paramIntermediaAni;
          disp.meta01 = paramIntermediaDni;
          disp.meta05 = callType;
        }
        dispatch({
          type: "store-disposition-code",
          payload: disp
        });
      }
      else {
        // for subject
         let payload={}
        if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& (contact_center_type==='intermedia' || contact_center_type==='inContact')){
          payload= {
            subjectid: getsessionresp[0].subjectID,
            dnis: choosecaller.dnis,
            token:tokenstat,
            tokenstr: tokengen
          }
        }
        else{
          payload= {
            subjectid: getsessionresp[0].subjectID,
            dnis: choosecaller.dnis,
          } 
        }
        dispatch({
          type: actionType,
          payload: payload
        });

        // for source

        if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& (contact_center_type==='intermedia' || contact_center_type==='inContact')){
         payload=  {
          sourceid: getsessionresp[0].sourceID,
          token:tokenstat,
          tokenstr:tokengen
        }
        }
        else{
          payload=  {
            sourceid: getsessionresp[0].sourceID,
          }
        }
        dispatch({
          type: actionType,
          payload: payload
        })

        if(!btgenable && getEHRProvider()==='epic'){
          dispatch({
            type: "one-state-btgpatient/fetch",
            payload: {
              identifier: getsessionresp[0].subjectID
            }
          })
          setTimeout(()=>{
            dispatch({
              type: "one-state-btgpatient/fetch",
              payload: {
                identifier: getsessionresp[0].sourceID
              }
            })
          },2000)
        }
         dispatch({
      type: 'one-state-patient-verified/set',
      payload: {
        verified: true,
      },
    });
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            visible: false
          }
        });
        
        dispatch(setSourceType(sourceTypeSession));
        dispatch(selectSourceType(sourceTypeSession[1]));
        dispatch(setPatientMatchTypeAction(PatientMatchType.SINGLE_MATCH));
      }

    } else if (getsessionresp?.length === 0) {
      // avoiding lookup api calling when application loads
      const aninumber = sessionStorage.getItem("ani");
      const dninumber = sessionStorage.getItem("dnis");

      if(contact_center_type === "vonage" && aninumber?.length>0) {
        dispatch({
          type: actionType,
          payload: {
            number: aninumber,
            dnis: dninumber,
            userid: agentIdValue,
            useridtype : useridtype
          }
        });
        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
      } else if(contact_center_type === "twilio" && choosecaller?.number) {
        dispatch({
          type: actionType,
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            userid: agentIdValue,
            useridtype : useridtype
          }
        });
        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
      } else if(contact_center_type === "wxcc" && choosecaller?.number) {
        dispatch({
          type: actionType,
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            userid: agentIdValue,
            useridtype : useridtype
          }
        });
        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
      } else if(contact_center_type === "five9" && choosecaller?.number) {
        dispatch({
          type: actionType,
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            userid: agentIdValue,
            useridtype : useridtype
          }
        });

        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
      } else if(contact_center_type === "genesys" && genesysinteraction?.flowdata) {
        let callerani = "",callerdnis = "";
        if (genesysinteraction.flowdata.participants?.length > 0) {
          if (genesysinteraction.flowdata.participants[0]?.ani?.length === 16) {
            callerani = genesysinteraction.flowdata.participants[0].ani.slice(6);
          }
          if (genesysinteraction.flowdata.participants[0]?.dnis?.length === 16) {
              callerdnis = genesysinteraction.flowdata.participants[0].dnis.slice(6);
              sessionStorage.setItem("genesys_dnis",callerdnis)
          }
        }
        if (callerani?.length > 0) {
          dispatch({
            type: actionType,
            payload: {
              number: callerani,
              dnis: callerdnis,
              userid: agentIdValue,
            useridtype : useridtype
            }
          });
  
          dispatch({
            type: "getcallerdetails",
            payload: {
              number: choosecaller.number,
              type: "Patient"
            }
          });
        }
      } else if(contact_center_type === "inContact" && choosecaller?.number) {
        let payload={}
        if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& (contact_center_type==='inContact')){
          payload={
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            token:tokenstat,
            tokenstr: tokengen,
            userid: agentIdValue,
            useridtype : useridtype
          }
        }
        else{
          payload={
            number: choosecaller.number,
            dnis: choosecaller.dnis,
          }
        }
        dispatch({
          type: actionType,
          payload: payload
        });
      }
      else if(contact_center_type === "ringcentral" && ringcentralCalldata?.values?.to?.length>0) {
        dispatch({
          type: actionType,
          payload: {
            number: ringcentralCalldata?.values?.to,
            dnis: ringcentralCalldata?.values?.from,
            userid: agentIdValue,
            useridtype : useridtype
          }
      });
      dispatch({
        type: "getcallerdetails",
        payload: {
          number: ringcentralCalldata?.values?.from,
          type: "Patient"
        }
      });
    
      }
      else if(contact_center_type === "intermedia" && choosecaller?.number) {
        let payload={}
        if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& (contact_center_type==='intermedia')){
          payload={
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            token:tokenstat,
            tokenstr: tokengen,
            userid: agentIdValue,
            useridtype : useridtype
          }
        }
        else{
          payload={
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            userid: agentIdValue,
            useridtype : useridtype
          }
        }
        dispatch({
          type: actionType,
          payload: payload
        });

        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
      }
      else if(contact_center_type === "glia" && choosecaller?.number) {
        dispatch({
          type: actionType,
          payload: {
            number: choosecaller.number,
            dnis: choosecaller.dnis,
            userid: agentIdValue,
            useridtype : useridtype
          }
        });

        dispatch({
          type: "getcallerdetails",
          payload: {
            number: choosecaller.number,
            type: "Patient"
          }
        });
      }

    }
  }, [getsessionresp, callType]);

  useEffect(() => {
    if(contact_center_type && contact_center_type === 'finesse'){
      // I'm using a 3s timeout here to allow the agentId to make it into the gadget before I make the request.
      setTimeout(() => {
        if (agentId) {
          //startHealthCheck(settings, agentId, settings);
          dispatch({
            type: "healthAlert",
            payload: {
                agentId: agentId,
            }
        });
        }
      }, 5000);
    // This health check hits the Agenta server immediately, as soon as the gadget loads.
    // This will allow us to see if there's a cert issue or a connection issue with the Agenta server.
    }
    // if(contact_center_type && contact_center_type === 'vonage'){
    //   dispatch({
    //     type: "one-state-getsession/fetch",
    //     payload: {
    //         sessionKey:sessionStorage.getItem("vonageInteractionId")
    //     }
    // });
    // }
    
  }, []);

  useEffect(() => {
    if(five9Store && five9Store?.globalsearch != five9logout){
      setFive9Logout(five9Store?.globalsearch);
    }
  }, [five9Store]);

  useEffect(()=>{
    if(patients?.selected) {
      dispatch({
        type:"one-state-selectedsubject/set",
        payload: patients?.selected
      })
    }
    if(source?.selected) {
      dispatch({
        type:"one-state-selectedsource/set",
        payload: source?.selected
      })
    }
    if(patients?.selected && source?.selected) {
      if(contact_center_type === 'finesse' || contact_center_type === 'five9') {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "vonage") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:vonageInteractionId?.interactionId,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "twilio") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:paramTwilioSid,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }

      else if(contact_center_type === "wxcc") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:wxccInteraction?.wxccInteractionId,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "genesys") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id: genesysinteraction?.flowdata?.id,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "inContact") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:paramInContactSid,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "ringcentral") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:ringcentralCalldata?.values?.sessionId,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "intermedia") {
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:paramIntermediaSid,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }
      else if(contact_center_type === "glia") {
        let GliaSessionkey = sessionStorage.getItem("GliaInteractionID")
        dispatch({
          type:"one-state-setsession/fetch",
          payload: {
           id:GliaSessionkey,
           subjectID: patients.selected.id,
           sourceID: source.selected.id
          }
        })
      }

    }
  },[patients,source])

  /**
   * To check if the PatientLookup API is down
   */
   useEffect(() => {
     //If the patienterror contains the error object.If soit will display a error notification.
    if(patienterror && Object.keys(patienterror).length > 0 && patients.selected === undefined) {
      if(patienterror?.erroritems?.length > 0) {
        patienterror.erroritems.forEach((subjecterror:any)=> {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 10
          });
          notification['error']({
            message: subjecterror.display_text,
            description: "",
          });
        })
      }
      else if(patienterror?.status == 500 && patienterror?.erroritems?.length === 0) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 10
        });
        notification['error']({
          message: "",
          description: "Unable to connect to the data server",
        });
      }
    }
  }, [patienterror]);

  useEffect(() => {
  //If the pendingreferrals contains the error object.If soit will display a error notification.
    if(referrals?.error) {
      if(referrals?.error?.erroritems?.length > 0) {
        referrals?.error?.erroritems.forEach((e: any) => {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 10
          });
          notification['error']({
            message: "",
            description: e.display_text,
          });
        })
      } else if(referrals?.error?.status == 500) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 10
        });
        notification['error']({
          message: "",
          description: "Unable to connect to the data server",
        });
      }
      dispatch({
        type: 'one-state-pending-referrals/set-error',
        payload: null
      });
    }
  }, [referrals?.error]);

  useEffect(() => {
    //If the pendingreferrals contains the error object.If so it will display a error notification.
      if(apptstable?.error) {
        if(apptstable?.error?.erroritems?.length > 0) {
          apptstable?.error?.erroritems.forEach((e: any) => {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 10
            });
            notification['error']({
              message: "",
              description: e.display_text,
            });
          })
        } else if(apptstable?.error?.status == 500) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 10
          });
          notification['error']({
            message: "",
            description: "Unable to connect to the data server",
          });
        }
        dispatch({
          type: 'one-state-appointments/set-error',
          payload: null
        });
      }
    }, [apptstable?.error]);


  const globalSelectedPatient = (selectedpatient: any)=> {
    //To check if the consolidaated api is true or false
    if (consolidated_api_invocation) {
      dispatch(setPatientSelectedAction(selectedpatient));
    }
    else {
      sessionStorage.setItem("PatientName",selectedpatient.id);
      sessionStorage.setItem("subjectid", selectedpatient.id);
      let ehrProvider = sessionStorage.getItem('ehr');

      if(ehrProvider === 'epic') {
        dispatch(setSelectedAction(selectedpatient));
      } else if(ehrProvider === 'athena') {
        dispatch(setSelectedAthenaAction(selectedpatient));
      } else if(ehrProvider === 'cerner') {
        dispatch(setSelectedCernerAction(selectedpatient));
      }
      else if(ehrProvider === 'meditech'){
        dispatch(setSelectedMeditechAction(selectedpatient))
      }
      else if(ehrProvider === 'nextgen'){
        dispatch(setSelectedNextgenAction(selectedpatient))
      }
      else if(ehrProvider === 'ecw'){
        dispatch(setSelectedECWAction(selectedpatient))
      }
    }

    // In screenpop mode, also populate the Source card with the selected patient
    // so that Source doesn't remain stuck in skeleton/empty state
    const screenpopAni = (() => {
      try { return new URLSearchParams(window.location.search).get('ani') || ''; }
      catch (e) { return ''; }
    })();
    if (screenpopAni && !source?.selected?.id) {
      dispatch(addSourceAction(selectedpatient));
      dispatch(selectAction(selectedpatient.id));
      dispatch(setSkeletonAction({ source_skeleton: false } as Skeleton));
    }

    dispatch(reinitPatientSearchAction());
    dispatch({
      type: 'one-state-patient-verified/set',
      payload: {
        verified: true,
      },
    });
    let globalSearchSubjectSelected: Skeleton = {
      upcomingAppts_skeleton: true,
      pendingReferrals_skeleton: true,
      pendingBills_skeleton: true,
      insurance_skeleton: true,
      pendingCare_skeleton: true,
      pharmacies_skeleton: true,
      prescription_skeleton: true,
    };
    dispatch(setSkeletonAction(globalSearchSubjectSelected));
    //Reset the hook after the functtion call.
    setGlobalPatientSelected({})
  }

    //To check whether the Select patient is a BTG patient or not
    useEffect(() => {
      //To Check if we get error for PatientSearch API
      if(Object.keys(btgpatientdata).length > 0 && btgpatientdata?.error && Object.keys(btgpatientdata.error).length > 0 && btgenable) {
        //To check if the erroritems array is present.
        if(btgpatientdata?.error?.erroritems?.length > 0) {
          btgpatientdata.error.erroritems.forEach((errorinfo: any)=> {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 10
            });
            notification['error']({
              message: "",
              description: errorinfo.display_text,
            });
          })
        }
        else if(btgpatientdata?.error?.status == 500 && btgpatientdata?.error?.erroritems?.length === 0) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 10
          });
          notification['error']({
            message: "",
            description: "Unable to connect to the data server",
          });
        }
      }
      //Check if the ResourceType is OperationOutcome  then it is a BTG Patient.
      else if(btgpatientdata?.patientbtgdata?.resourceType === "OperationOutcome" && btgenable) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 10
        });
        notification['error']({
          message: "",
          description: btgmessage,
        });
      }
      //If the ResourceType value is Patient then it is a NON-BTG Patient.
      else if (btgpatientdata?.patientbtgdata?.resourceType === "Patient" && btgenable && Object.keys(globalpatientselected)?.length > 0) {
        globalSelectedPatient(globalpatientselected)
      }

    },[btgpatientdata]);

  //Code for Auto-Screenpop
  useEffect(() => {
    /**
     * Checking if a Patient is selected
     * Type of the screenpop in settings file is receive_communication
     * The Autoscreenpop value in the  settings file is true
     */

    if(patients && patients?.selected?.id && (screenpop_type === 'receive_communication' || screenpop_type === 'receive_communication02' ) && autoscreenpop && !btgenable) {
      // Storing the epicuserid id valiue initially as agentId
      let agentIdValue = agentId;let calldnisdata = choosecaller.dnis;
      //To check for the contact center type and update the  agentIDValue
        if (contact_center_type && contact_center_type === 'five9') {
          //This is for Five9
          agentIdValue = sessionStorage.getItem("five9_userid");
        }
        else if (contact_center_type && contact_center_type === 'vonage' ) {
          //This is for Vonage
          agentIdValue = sessionStorage.getItem("vonage_userid")
        }
        else if (contact_center_type && contact_center_type === 'inContact' ) {
          //This is for Vonage
          agentIdValue = sessionStorage.getItem("NiceEpicUserID")
        }
        else if (contact_center_type && contact_center_type === 'twilio' ) {
          //This is for Twilio
          agentIdValue = sessionStorage.getItem("twilio_userid")
        }
        else if (contact_center_type && contact_center_type === 'ringcentral' ) {
          //This is for ringcentral
          agentIdValue = sessionStorage.getItem("ringcentral_agentName")
        }
        else if(contact_center_type === "genesys") {
          //This is for Genesys
          agentIdValue = genesysagentdata
          calldnisdata = sessionStorage.getItem("genesys_dnis");
        }
        else if (contact_center_type && contact_center_type === 'wxcc' ) {
          //This is for Vonage
          agentIdValue = epicuserid?.agentuserid;
        }
        else if (contact_center_type && contact_center_type === 'intermedia' ) {
          //This is for Intermedia
          agentIdValue = sessionStorage.getItem("intermedia_userid")
        }
        // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
        if (sso === false ) {
          agentIdValue = epicuserid?.agentuserid;
        }
        const patientId = patients?.selected?.id
        const sobject: ReceiveCommModel = {
          //The Context value is the screenpop key 
          context: autoscreenpop_default_context,
          // The selected patients ID
          patientId: patientId ? patientId : "",
          //AgentId is either the epicuserid or agentID based on the  sso value
          agentId: agentIdValue,
          //This value is  configurable (Example value: External)
          useridtype: useridtype,
          //This value is  configurable (Example value: Patient/None)
          lookuptype: lookuptype,
          // DNIS value
          callId: calldnisdata,
          //Type of Call
          contactType: 'Incoming',
          //Type of Communication
          communicationType: 'Phone',
          //ANI
          phoneNumber: choosecaller?.number,
          //PatientID Type
          type: patientId ? searchID : "",
        }
       //Dispatching for Screenpop
        dispatch(ReceiveCommAction(sobject));
        //Dispostion Auto Screenpop
        let disp: Disposition = { value: "2030" }
        disp.dial_list_uid = interactionId;
        disp.meta00 = agentIdValue;
        disp.meta01 = teamName;
        disp.meta02 = epicuserid?.agentuserid
        disp.meta03 = autoscreenpop_default_context
        disp.meta04 = patientId;
        disp.meta05 = 'Auto Screenpop';
        dispatch({
          type: "store-disposition-code",
          payload: disp
        })
    } 
    else if(patients && patients?.selected?.id && (screenpop_type === 'receive_communication03' ) && autoscreenpop && !btgenable){
      const sourceId = sessionStorage.getItem("sourceid");
      let useragentid=""
      let calldnisdata = choosecaller.dnis
      // Storing the epicuserid id valiue initially as agentId
       let agentIdValue = agentId;
       //To check for the contact center type and update the  agentIDValue
         if (contact_center_type && contact_center_type === 'five9') {
           //This is for Five9
           agentIdValue = sessionStorage.getItem("five9_userid");
           useragentid=sourceId ? sourceId : null
         }
         else if (contact_center_type && contact_center_type === 'finesse' ) {
          //This is for Vonage
          useragentid=sessionStorage.getItem("finesse_uid")
        }
         else if (contact_center_type && contact_center_type === 'vonage' ) {
           //This is for Vonage
           agentIdValue = sessionStorage.getItem("vonage_userid")
           useragentid=sessionStorage.getItem("vonageInteractionId")
         }
         else if (contact_center_type && contact_center_type === 'inContact' ) {
           //This is for Vonage
           agentIdValue = sessionStorage.getItem("NiceEpicUserID")
           useragentid=sessionStorage.getItem("Incontact_uid")
         }
         else if (contact_center_type && contact_center_type === 'twilio' ) {
           //This is for Twilio
           agentIdValue = sessionStorage.getItem("twilio_userid")
           useragentid=sessionStorage.getItem("twilio_uid")
         }
         else if (contact_center_type && contact_center_type === 'ringcentral' ) {
           //This is for ringcentral
           agentIdValue = sessionStorage.getItem("ringcentral_agentName")
           useragentid=sessionStorage.getItem("rc_uid")
         }
         else if(contact_center_type === "genesys") {
           //This is for Genesys
           agentIdValue = genesysagentdata
           calldnisdata = sessionStorage.getItem("genesys_dnis");
           useragentid=sessionStorage.getItem("genesys_uid")
         }
         else if (contact_center_type && contact_center_type === 'wxcc' ) {
           //This is for Vonage
           agentIdValue = epicuserid?.agentuserid;
           useragentid=wxccInteraction?.taskMap?.interactionId
         }
         else if (contact_center_type && contact_center_type === 'intermedia' ) {
          //This is for Intermedia
          agentIdValue = sessionStorage.getItem("intermedia_userid")
          useragentid=sessionStorage.getItem("intermedia_uid")
        }
         // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
         if (sso === false ) {
           agentIdValue = epicuserid?.agentuserid;
         }
         const patientId = patients?.selected?.id
         const sobject: ReceiveCommModel = {
           //The Context value is the screenpop key 
           context: autoscreenpop_default_context,
           // The selected patients ID
           patientId: patientId ? patientId : "",
           //AgentId is either the epicuserid or agentID based on the  sso value
           agentId: agentIdValue,
           //This value is  configurable (Example value: External)
           useridtype: useridtype,
           //This value is  configurable (Example value: Patient/None)
           lookuptype: lookuptype,
           // DNIS value
           callId: useragentid,
           //Type of Call
           contactType: 'Incoming',
           //Type of Communication
           communicationType: 'Phone',
           //ANI
           phoneNumber: choosecaller?.number,
           //PatientID Type
           type: patientId ? searchID : "",

           DialedPhoneNumber:calldnisdata,

         }
        //Dispatching for Screenpop
         dispatch(ReceiveCommAction(sobject));
         //Dispostion Auto Screenpop
         let disp: Disposition = { value: "2030" }
         disp.dial_list_uid = interactionId;
         disp.meta00 = agentIdValue;
         disp.meta01 = teamName;
         disp.meta02 = epicuserid?.agentuserid
         disp.meta03 = autoscreenpop_default_context
         disp.meta04 = patientId;
         disp.meta05 = 'Auto Screenpop';
         dispatch({
           type: "store-disposition-code",
           payload: disp
         })
    }
  },[patients]);

  useEffect(() => {

    if(contact_center_type && contact_center_type === 'finesse') {
      // Fetching information for getepicuserid
      if(agentId) {
        dispatch({
          type: "one-state-getuserid/fetch",
          payload: {
            agentuserid: agentId,
            
          }
        });
      //Fetch Panviva User ID
     dispatch({
      type: "one-state-getpanvivaid/fetch",
      payload: {
        agentuserid: agentId,
        
      }
    });
       }
    }
    else if(contact_center_type && contact_center_type === 'five9') {
      let agentIdValue = sessionStorage.getItem("five9_userid");
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
      //Fetch Panviva User ID
     dispatch({
      type: "one-state-getpanvivaid/fetch",
      payload: {
        agentuserid: agentIdValue,
        
      }
    });
     }
     }
     else if(contact_center_type && contact_center_type === 'vonage') {
      let agentIdValue = vonage_userId;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      if(getEHRProvider() === 'epic') {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
    }
    //Fetch Panviva User ID
    setTimeout(()=>{
      dispatch({
        type: "one-state-getpanvivaid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
    },3000)
    
     }

     }
  },[]);
  useEffect(()=>{
    setRingLog(ringcentrallogin?.values?.loggedIn)
  },[ringcentrallogin]);

  useEffect(()=>{
     if(contact_center_type && contact_center_type === 'twilio') {
      let agentIdValue = paramTwilioAgentName;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
      //Fetch Panviva User ID
     dispatch({
      type: "one-state-getpanvivaid/fetch",
      payload: {
        agentuserid: agentIdValue,
        
      }
    });
     }
     }
  },[paramTwilioAgentName])

  useEffect(()=>{
    if(contact_center_type && contact_center_type === 'vonage') {
      let agentIdValue = vonage_userId;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      if(getEHRProvider() === 'epic') {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
    }
      //Fetch Panviva User ID
      dispatch({
        type: "one-state-getpanvivaid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
     }
  },[vonage_userId])
 
  useEffect(()=>{
    if(contact_center_type && contact_center_type === 'genesys') {
      let genesys_userid =sessionStorage.getItem("agentName")
      let agentIdValue = genesys_userid;
      // Fetching information for getepicuserid
    if(agentIdValue) {
      dispatch({
        type: "one-state-getuserid/fetch",
        payload: {
          agentuserid: agentIdValue,
          
        }
      });
    //Fetch Panviva User ID
     dispatch({
      type: "one-state-getpanvivaid/fetch",
      payload: {
        agentuserid: agentIdValue,
        
      }
    });
     }
     }
  },[genesysagentdata]) 

  useEffect(()=>{
    if(contact_center_type && contact_center_type === 'inContact') {
      // Determine agent ID value based on SSO and parameter availability
      let agentIdValue = null;
      let fetchUserIdFlag = false;

      if (sso === true) {
        // If SSO is true and agentuserid has value, don't fire one-state-getuserid/fetch
          if(epic_id_format === "agentid") {
                      agentIdValue = paramInContactAgentID;
          }
           if(epic_id_format === "agentname") {
                      agentIdValue = paramInContactAgentName ;
          }
                    fetchUserIdFlag = false;
      } else if (sso === false) {
        // If SSO is false
    
          // If paramIncontactEpicExternalID doesn't have value, use configurable agent ID
          // Default to ParamInContactAgentName, but can be configured to use ParamInContactAgentID
          if(epic_id_format === "agentid") {
                      agentIdValue = paramInContactAgentID;
          }
           if(epic_id_format === "agentname") {
                      agentIdValue = paramInContactAgentName ;
          }

          fetchUserIdFlag = true;
        
      }

      // Update the state flag
      setShouldFetchUserId(fetchUserIdFlag);

      // Fetch user ID only when conditions are met
      if (agentIdValue && fetchUserIdFlag && !paramInContactEpicExternalID) {
        dispatch({
          type: "one-state-getuserid/fetch",
          payload: {
            agentuserid: agentIdValue,
          }
        });
      }

      // Always fetch Panviva User ID if agentIdValue is available
      if (agentIdValue) {
        dispatch({
          type: "one-state-getpanvivaid/fetch",
          payload: {
            agentuserid: agentIdValue,
          }
        });
      }
    }
  },[paramInContactAgentName, paramInContactAgentID, paramInContactEpicExternalID, sso])

  /**
   * Show notification for When Agenta Server is down
   */
  useEffect(() => {
    
    if(monitor?.notifiy){
        notification.config({
          placement: "topRight",
          top: 50,
          duration: 0
        });
        const btn = (
          <Button type="primary" size="small">
            <a href={monitor?.healthCheckUrl} target="_blank">Click Here</a>
          </Button>
        );
        notification['error']({
          message: 'Error connecting with Agenta Server. To attempt fixing a certificate error...',
          description: "",
          btn
        });

        dispatch(
          {
            type: "one-state-errorhandle/setnotification",
            payload: {
              notifiy: false
            }
          }
        )
    }
    
  }, [monitor]);

if(queryparameter && contact_center_type !== "twilio" && contact_center_type !== 'inContact' && contact_center_type !== 'intermedia' ) {
  useEffect(() => {
    const searchparameter = queryString.parse(window.location.search);
    console.log('[CCW-SCREENPOP] Query params:', JSON.stringify(searchparameter));
    console.log('[CCW-SCREENPOP] contact_center_type:', contact_center_type);
    console.log('[CCW-SCREENPOP] queryparameter:', queryparameter);
    
    if(searchparameter?.action === "start") {
      if(searchparameter?.ani) {
        console.log('[CCW-SCREENPOP] ANI:', searchparameter.ani, 'DNIS:', searchparameter.dnis);

        let skeletondata: Skeleton = {
          source_skeleton: true,
          subject_skeleton: true,
          callingDestination_skeleton: true
        }
  
        dispatch({
          type: "one-state-choosecaller/set",
          payload: {
            number: searchparameter.ani,
            dnis: searchparameter.dnis,
            visible: true,
            start: true
          }
        });

        setEHRProvider();
        const activeEhr = getEHRProvider();
        console.log('[CCW-SCREENPOP] Active EHR:', activeEhr);
  
        let actionType = '';

        switch(activeEhr) {
          case 'epic':
            actionType = 'caller-patient';
            break;
          case 'athena':
            actionType = 'caller-patient-athena';
            break;
          case 'cerner':
            actionType = 'caller-patient-cerner';
            break;
          case 'meditech':
              actionType = 'caller-patient-meditech';
              break;
            case 'nextgen':
              actionType = 'caller-patient-nextgen';
              break;
        }

        console.log('[CCW-SCREENPOP] Dispatching patient lookup:', actionType, 'with payload:', { number: searchparameter.ani, dnis: searchparameter.dnis });
        
        dispatch({
          type: actionType,
          payload: {
            number: searchparameter.ani,
            dnis: searchparameter.dnis
          }
        });
  
        console.log('[CCW-SCREENPOP] Dispatching getcallerdetails for:', searchparameter.ani);
        dispatch({
          type: "getcallerdetails",
          payload: {
            number: searchparameter.ani,
            type: "Patient"
          }
        });
  
        dispatch(setSkeletonAction(skeletondata));
      } else {
        console.log('[CCW-SCREENPOP] action=start but no ANI found');
      }
    } else {
      console.log('[CCW-SCREENPOP] No action=start, resetting. Params:', searchparameter);
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
        }
      });
    
      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible: false,
          start: true
        }
      });
    }
  }, []);
}

if (queryparameter && contact_center_type === "twilio") {
  const searchparameter = queryString.parse(window.location.search);
  useEffect(()=>{
    setParamTwilioAgentName(searchparameter?.agentName)
    sessionStorage.setItem("twilio_userid",searchparameter?.agentName);
    sessionStorage.setItem("twilio_uid",searchparameter?.sid);
    setParamTwilioAni(searchparameter?.ani)
    if (searchparameter?.action === "start" && searchparameter?.ani?.length>0) {
      setParamTwilioSid(searchparameter?.sid);
      setParamTwilioDni(searchparameter?.dnis);

      let skeletondata: Skeleton = {
        source_skeleton: true,
        subject_skeleton: true,
        callingDestination_skeleton: true
      }

      dispatch(setSkeletonAction(
        skeletondata
      ));
      dispatch({
        type: "one-state-getsession/fetch",
        payload: {
          sessionKey: searchparameter?.sid
        }
      });
 //Dispostion for Incoming Calls
 let disp: Disposition = { value: "193" }
 disp.dial_list_uid = paramTwilioSid;
 disp.meta00 = paramTwilioAgentName;
 disp.meta01 = "";//need to check for skillname
 disp.meta02 = paramTwilioAni;
 disp.meta03 = paramTwilioDni;
 disp.meta04 = paramTwilioSid;
 disp.meta05 = 'Incoming Call';
 dispatch({
   type: "store-disposition-code",
   payload: disp
 });
      dispatch({
        type: "one-state-choosecaller/set",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible: true,
          start: true
        }
      });

      setEHRProvider();

      let actionType = '';
      switch (getEHRProvider()) {
        case 'epic':
          actionType = 'caller-patient';
          break;
        case 'athena':
          actionType = 'caller-patient-athena';
          break;
        case 'cerner':
          actionType = 'caller-patient-cerner';
          break;
        case 'meditech':
            actionType = 'caller-patient-meditech';
            break;
        case 'nextgen':
            actionType = 'caller-patient-nextgen';
            break;
      }

      dispatch({
        type: actionType,
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
        }
      });
      dispatch({
        type: "getcallerdetails",
        payload: {
          number: searchparameter.dnis,
          type: "Patient"
        }
      });
    } else if(searchparameter?.action === "hangup") {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
        }
      });
      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible: false,
          start: true
        }
      });
  
      setParamTwilioAni(null);
      setParamTwilioDni(null);
      setParamTwilioSid(null);
      setParamTwilioAgentName(null)
      sessionStorage.removeItem("twilio_userid")
      sessionStorage.removeItem("PatientName");
    } else {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
        }
      });
      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible:false,
          start:true
        }
      });
      sessionStorage.removeItem("PatientName");
      sessionStorage.removeItem("sourceid");
      sessionStorage.removeItem("subjectid");
    }
  },[]);
}

//incase of Incontact we reading query parameters from url/FQDN
//the parameters are send to getsession api for validating unique id for call variables
if(queryparameter && contact_center_type === "inContact"){
  const searchparameter = queryString.parse(window.location.search);

  useEffect(() => {
    setParamInContactAgentID(searchparameter?.agentId)
    setParamInContactSkillName(searchparameter?.skillname);
    setParamInContactAgentName(searchparameter?.agentFirstName + ' ' + searchparameter?.agentLastName)
    sessionStorage.setItem("inContact_userid", searchparameter?.agentId);
    sessionStorage.setItem("Incontact_SkillName",searchparameter?.skillname)
    sessionStorage.setItem("agentName", searchparameter?.agentFirstName + ' ' + searchparameter?.agentLastName);
    sessionStorage.setItem("Incontact_uid",searchparameter?.contactId)
     sessionStorage.setItem("NiceEpicUserID", searchparameter?.epicExternalID);
     setParamInContactEpicExternalID(searchparameter?.epicExternalID)
    if (searchparameter?.epicExternalID) {
      console.log("epicExternalID", searchparameter?.epicExternalID)
      console.log("About to dispatch one-state-getuserid/fetch with payload:", {
        agentuserid: searchparameter?.epicExternalID
      });
           sessionStorage.setItem("NiceEpicUserID", searchparameter?.epicExternalID);
      try {
        dispatch({
            type: "one-state-getuserid/set",
            payload: {
                agentuserid: searchparameter?.epicExternalID
            }
        });
        console.log("Dispatch completed successfully");
      } catch (error) {
        console.error("Error in dispatch:", error);
      }
    }
    else{
    
        let agentIdsession=''
          if(epic_id_format === "agentid") {
                      agentIdsession = searchparameter?.agentId;
          }
           if(epic_id_format === "agentname") {
                      agentIdsession = searchparameter?.agentFirstName + ' ' + searchparameter?.agentLastName ;
          }
             sessionStorage.setItem("NiceEpicUserID", agentIdsession);
      
    }
    sessionStorage.removeItem("genderIdentity")
    setParamInContactAni(searchparameter?.ani)
    
    if(searchparameter?.action === "start") {
      setParamInContactSid(searchparameter?.contactId);
      let substring=getSubstrings(searchparameter?.dnis)
      let tokenstr=searchparameter?.token;
      setParamInContactDni(substring[0])
      
      let tokenstat =substring[2]?substring[2]:""
      sessionStorage.setItem('tokenstat',tokenstat)
      sessionStorage.setItem('tokenstring',searchparameter?.token)

      setTokengen(searchparameter?.token)
      if(searchparameter?.token?.length>0){
        setInContactsearch(true)
      }
      setTokenstat(tokenstat)
      let skeletondata: Skeleton = {
        source_skeleton: true,
        subject_skeleton: true,
        callingDestination_skeleton: true
      }

      dispatch({
        type: "one-state-choosecaller/set",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible: true,
          start: true
        }
      });

      setEHRProvider();

      let actionType = '';

      switch(getEHRProvider()) {
        case 'epic':
          actionType = 'caller-patient';
          break;
        case 'athena':
          actionType = 'caller-patient-athena';
          break;
        case 'cerner':
          actionType = 'caller-patient-cerner';
          break;
        case 'meditech':
            actionType = 'caller-patient-meditech';
            break;
         case 'nextgen':
            actionType = 'caller-patient-nextgen';
            break;
      }
      let payload={}

      if((getEHRProvider()==='athena' || getEHRProvider()==='epic')&& contact_center_type==='inContact'){
        payload={
          number: searchparameter.ani,
          dnis: substring[0],
          token:tokenstat,
          tokenstr: tokenstr
        }
      }
      else{
        payload={
          number: searchparameter.ani,
          dnis: substring[0],
        }
      }
      dispatch({
        type: actionType,
        payload: payload
      });

      dispatch({
        type: "getcallerdetails",
        payload: {
          number: searchparameter.ani,
          type: "Patient"
        }
      });

      dispatch(setSkeletonAction(
        skeletondata
      ));

      dispatch({
        type: "one-state-getsession/fetch",
        payload: {
          sessionKey: searchparameter?.contactId
        }
      });
       //Dispostion for Incoming Calls
       let disp: Disposition = { value: "193" }
       disp.dial_list_uid = choosecaller?.callId;
       disp.meta00 = paramInContactAgentName;
       disp.meta01 = paramInContactSkillName;
       disp.meta02 = paramInContactAni;
       disp.meta03 = paramInContactDni;
       disp.meta04 = paramInContactSid;
       disp.meta05 = 'Incoming Call';
       dispatch({
         type: "store-disposition-code",
         payload: disp
       });
    } else if(searchparameter?.action === "hangup") {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
        }
      });

      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible: false,
          start: true
        }
      });
    
      setParamInContactAni(null);
      setParamInContactDni(null);
      setParamInContactSid(null);
      setParamInContactAgentName(null);
      setParamInContactSkillName(null);

      sessionStorage.removeItem("inContact_userid");
      sessionStorage.removeItem("NiceEpicUserID");
      sessionStorage.removeItem("agentName");
      sessionStorage.removeItem("PatientName");
      sessionStorage.removeItem('tokenstat')
      sessionStorage.removeItem('tokenstring')
      sessionStorage.removeItem("genderIdentity")
    } else {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis
        }
      });

      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: searchparameter.dnis,
          visible: false,
          start: true
        }
      });

      setParamInContactAni(null);
      setParamInContactDni(null);
      setParamInContactSid(null);
      sessionStorage.removeItem("PatientName");
      sessionStorage.removeItem('tokenstat')
      sessionStorage.removeItem('tokenstring')
      sessionStorage.removeItem("genderIdentity")
      sessionStorage.removeItem("NiceEpicUserID");
    }
  }, []);
}

//incase of Intermedia we reading query parameters from url/FQDN
//the parameters are send to getsession api for validating unique id for call variables
if(queryparameter && contact_center_type === "intermedia"){
  const searchparameter = queryString.parse(window.location.search);

  useEffect(() => {
    setParamIntermediaAni(searchparameter?.ani)
   
    if(searchparameter?.action === "start") {
            // setParamIntermediaSid(searchparameter?.callid);
      // Call the advanced sessions API function
      handleIntermediaSessionsApi(searchparameter, token_intermedia);
       
      // Original simple API call (commented out for comparison)
// fetch(
//  // `https://pop6-apps.mycontactcenter.net/api/v1/hist/incomingvoicecall/315bb3d0-1605-4ed7-9eec-fc4efb2011e1'
//  `${agentid_url}${searchparameter?.callid}`
//  , {
//  method: 'GET',
//  headers: {
//    'Content-Type': 'application/json',
//    'token': token_intermedia
//  }
// })
      // Original simple API call (commented out for comparison)
// .then(response => {
//   if (!response.ok) {
//     throw new Error(`HTTP error! status: ${response.status}`);
//   }
//   return response.json();
// })
// .then(data => {
//   console.log('Incoming voice call history:', data);
//   
//   // Extract AgentId from the response
//   if (data && data.AnsweredHistory && data.AnsweredHistory.length > 0) {
//     const agentId = data.AnsweredHistory[0]?.AgentId;
//     console.log('AgentId captured:', agentId);
//     
//     // Store AgentId in session storage for later use
//     sessionStorage.setItem('intermedia_uid', agentId.toString());
//     
//    
//   } else {
//     console.log('No AgentId found in the response');
//   }
// })
// .catch(error => {
//   console.error('Error fetching incoming voice call history:', error);
// });

      setParamIntermediaSid(searchparameter?.callid);
      let substring=getSubstrings(searchparameter?.dnis)
      let tokenstr=searchparameter?.token;
      setParamIntermediaDni(substring[0])
      let tokenstat =substring[2]?substring[2]:""
      sessionStorage.setItem('tokenstat',tokenstat)
      sessionStorage.setItem('tokenstring',searchparameter?.token)

      setTokengen(searchparameter?.token)
      if(searchparameter?.token?.length>0){
        setIntermediasearch(true)
      }
      setTokenstat(tokenstat)
      let skeletondata: Skeleton = {
        source_skeleton: true,
        subject_skeleton: true,
        callingDestination_skeleton: true
      }

      dispatch({
        type: "one-state-choosecaller/set",
        payload: {
          number: searchparameter.ani,
          dnis: substring[0],
          visible: true,
          start: true
        }
      });

      setEHRProvider();

      let actionType = '';

      switch(getEHRProvider()) {
        case 'epic':
          actionType = 'caller-patient';
          break;
        case 'athena':
          actionType = 'caller-patient-athena';
          break;
        case 'cerner':
          actionType = 'caller-patient-cerner';
          break;
        case 'meditech':
            actionType = 'caller-patient-meditech';
            break;
        case 'nextgen':
            actionType = 'caller-patient-nextgen';
            break;
      }
    let payload={}
      if(getEHRProvider()==='athena'&& contact_center_type==='intermedia'){
        payload={
          number: searchparameter.ani,
          dnis: substring[0],
          token:tokenstat,
          tokenstr: tokenstr
        }
      }
      else{
        payload={
          number: searchparameter.ani,
          dnis: substring[0],
        }
      }
      dispatch({
        type: actionType,
        payload: payload
      });

      dispatch({
        type: "getcallerdetails",
        payload: {
          number: searchparameter.ani,
          type: "Patient"
        }
      });

      dispatch(setSkeletonAction(
        skeletondata
      ));

      dispatch({
        type: "one-state-getsession/fetch",
        payload: {
          sessionKey: sessionStorage.getItem("intermedia_uid")
        }
      });
       //Dispostion for Incoming Calls
       let disp: Disposition = { value: "193" }
       disp.dial_list_uid = choosecaller?.callId;
       disp.meta00 = "";
       disp.meta01 = "";
       disp.meta02 = paramIntermediaAni;
       disp.meta03 = paramIntermediaDni;
       disp.meta04 = paramIntermediaSid;
       disp.meta05 = 'Incoming Call';
       dispatch({
         type: "store-disposition-code",
         payload: disp
       });
    } else if(searchparameter?.action === "hangup") {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: paramIntermediaDni
        }
      });

      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: paramIntermediaDni,
          visible: false,
          start: true
        }
      });
    
      setParamIntermediaAni(null);
      setParamIntermediaDni(null);
      setParamIntermediaSid(null);

      sessionStorage.removeItem("intermedia_userid");
      sessionStorage.removeItem("PatientName");
      sessionStorage.removeItem('tokenstat')
      sessionStorage.removeItem('tokenstring')
    } else {
      dispatch({
        type: "one-state-subject/reset",
        payload: {
          number: searchparameter.ani,
          dnis: paramIntermediaDni
        }
      });

      dispatch({
        type: "one-state-choosecaller/reset",
        payload: {
          number: searchparameter.ani,
          dnis: paramIntermediaDni,
          visible: false,
          start: true
        }
      });

      setParamIntermediaAni(null);
      setParamIntermediaDni(null);
      setParamIntermediaSid(null);
      sessionStorage.removeItem("PatientName");
      sessionStorage.removeItem('tokenstring')
      sessionStorage.removeItem('tokenstat')
    }
  }, []);
}
  /**
   *  build he necessary screenpop options and dispatch
   * @param activityId
   */
  const handleScreenPop = (activityId: string, from?: ScreenPopFrom) => {
    const patientContactNumber = patients?.selected?.contact;
    let formattedPhoneNumber = patientContactNumber?.replaceAll('-', '')
    if(screenpop_type === 'snap_adapter'){
      let agentIdValue = agentId;
      if (contact_center_type && contact_center_type === 'five9') {
        //This is for Five9
        agentIdValue = sessionStorage.getItem("five9_userid");
      }
      else if(contact_center_type === "genesys") {
        agentIdValue = genesysagentdata
      }
      const patientid = patients?.selected?.id
      const sobject: ScreenpopModel = {
        activityId,
        patientId: patientid ? patientid : nomatchid,
        eventType: event,
        location,
        agentId: agentIdValue,
        from: from
      }
      dispatch(screenpopAction(sobject));
    }else{
      if(screenpop_type === 'receive_communication' || screenpop_type === 'receive_communication02') {
      let agentIdValue = agentId;
      let calldnisdata = choosecaller.dnis
      if (contact_center_type && contact_center_type === 'five9') {
        //This is for Five9
        agentIdValue = epicuserid?.agentuserid;
      }
      else if(contact_center_type === "genesys") {
        agentIdValue = genesysagentdata
        calldnisdata = sessionStorage.getItem("genesys_dnis");
      }
      if (sso === false ) {
        agentIdValue = epicuserid?.agentuserid;
      }
      const patientid = patients?.selected?.id
      //ADPAC-1830
      const sobject: ReceiveCommModel = {
        context: activityId,
        patientId: patientid ? patientid : "",
        agentId: agentIdValue,
        useridtype: useridtype,
        lookuptype: lookuptype,
        callId: calldnisdata,
        contactType: 'Incoming',
        communicationType: 'Phone',
        phoneNumber: formattedPhoneNumber ? formattedPhoneNumber : choosecaller?.number,
        type: patientid ? searchID : "",
        from: from
      }
      dispatch(ReceiveCommAction(sobject));
    }
    else if(screenpop_type === 'receive_communication03'){
      const sourceId = sessionStorage.getItem("sourceid");
      let calldnisdata = choosecaller.dnis
      let useragentid=""
      // Storing the epicuserid id valiue initially as agentId
       let agentIdValue = agentId;
       //To check for the contact center type and update the  agentIDValue
         if (contact_center_type && contact_center_type === 'five9') {
           //This is for Five9
           agentIdValue = sessionStorage.getItem("five9_userid");
           useragentid=sourceId ? sourceId.value : null
         }
         else if (contact_center_type && contact_center_type === 'vonage' ) {
           //This is for Vonage
           agentIdValue = sessionStorage.getItem("vonage_userid")
           useragentid=sessionStorage.getItem("vonageInteractionId")
         }
         else if (contact_center_type && contact_center_type === 'inContact' ) {
           //This is for Vonage
           agentIdValue = sessionStorage.getItem("NiceEpicUserID")
           useragentid=sessionStorage.getItem("Incontact_uid")
         }
         else if (contact_center_type && contact_center_type === 'twilio' ) {
           //This is for Twilio
           agentIdValue = sessionStorage.getItem("twilio_userid")
           useragentid=sessionStorage.getItem("twilio_uid")
         }
         else if (contact_center_type && contact_center_type === 'ringcentral' ) {
           //This is for ringcentral
           agentIdValue = sessionStorage.getItem("ringcentral_agentName")
           useragentid=sessionStorage.getItem("rc_uid")
         }
         else if(contact_center_type === "genesys") {
           //This is for Genesys
           agentIdValue = genesysagentdata
           calldnisdata = sessionStorage.getItem("genesys_dnis");
           useragentid=sessionStorage.getItem("genesys_uid")
         }
         else if (contact_center_type && contact_center_type === 'wxcc' ) {
           //This is for Vonage
           agentIdValue = epicuserid?.agentuserid;
           useragentid=wxccInteraction?.taskMap?.interactionId
         }
         else if (contact_center_type && contact_center_type === 'intermedia' ) {
          //This is for Intermedia
          agentIdValue = sessionStorage.getItem("intermedia_userid")
          useragentid=sessionStorage.getItem("intermedia_uid")
        }
         // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
         if (sso === false ) {
           agentIdValue = epicuserid?.agentuserid;
         }
         const patientId = patients?.selected?.id
         const sobject: ReceiveCommModel = {
           //The Context value is the screenpop key 
           context: autoscreenpop_default_context,
           // The selected patients ID
           patientId: patientId ? patientId : "",
           //AgentId is either the epicuserid or agentID based on the  sso value
           agentId: agentIdValue,
           //This value is  configurable (Example value: External)
           useridtype: useridtype,
           //This value is  configurable (Example value: Patient/None)
           lookuptype: lookuptype,
           // DNIS value
           callId: useragentid,
           //Type of Call
           contactType: 'Incoming',
           //Type of Communication
           communicationType: 'Phone',
           //ANI
           phoneNumber: choosecaller?.number,
           //PatientID Type
           type: patientId ? searchID : "",

           DialedPhoneNumber:calldnisdata,

         }
        //Dispatching for Screenpop
         dispatch(ReceiveCommAction(sobject));
         //Dispostion Auto Screenpop
         let disp: Disposition = { value: "2030" }
         disp.dial_list_uid = interactionId;
         disp.meta00 = agentIdValue;
         disp.meta01 = teamName;
         disp.meta02 = epicuserid?.agentuserid
         disp.meta03 = autoscreenpop_default_context
         disp.meta04 = patientId;
         disp.meta05 = 'Auto Screenpop';
         dispatch({
           type: "store-disposition-code",
           payload: disp
         })
    }
    else if(screenpop_type === 'web_screenpop') {
      const patientid = patients?.selected?.id
      let pop_url = activityId + patientid;
      window.open(pop_url);
    }
    }

  }
  const checkRole = (authdata: any, feature: string, role: string) => {
    if (contact_center_type && contact_center_type === 'five9') {
      //This is for Five9
      role = sessionStorage.getItem("skillName");
    }
    let authorized = true;
    const show = authdata[feature]?.show;
    if ((show) && (show.length > 0)) {
      authorized = (
        show.indexOf(role) !== -1
      );
    }
    if (contact_center_type && contact_center_type === 'vonage') {
       authorized = true;
    }
    return authorized;
  };

  const killNotification = (checked: boolean) => {
      dispatch({
        type: "store-five9-notification",
        payload: checked
      });
  }

  //ADPAC-758
  const cardScreenpopData = (screenpopdata: []) => {
    let data_array: any[] = [];
    let count = 0;
    let screenpop_dataehr ='';
    let data ={}
    screenpopdata.forEach((screenpop_data: any) => {
      if (getEHRProvider() === 'epic' && screenpop_data.label && count<=0) {  
        screenpop_dataehr= screenpop_data?.label+' Epic'
         data = {
          id: screenpop_data?.id,
          label: screenpop_dataehr,
          onClick: () => {
            handleScreenPop(screenpop_data?.Activityid, ScreenPopFrom.SUBJECT_CARD);
          }
        }
        count +=1
         
    }
    if (getEHRProvider() === 'athena' && screenpop_data.label && count<=0) {  
      screenpop_dataehr= screenpop_data?.label+' Athena'
       data = {
        id: screenpop_data?.id,
        label: screenpop_dataehr,
        onClick: () => {
          // handleScreenPop(screenpop_data?.Activityid, ScreenPopFrom.SUBJECT_CARD);
        }
      }
      count +=1

  }
  if (getEHRProvider() === 'cerner' && screenpop_data.label && count<=0) {  
    screenpop_dataehr= screenpop_data?.label+' Cerner'
     data = {
      id: screenpop_data?.id,
      label: screenpop_dataehr,
      onClick: () => {
        // handleScreenPop(screenpop_data?.Activityid, ScreenPopFrom.SUBJECT_CARD);
      }
    }
    count +=1

}
if (getEHRProvider() === 'meditech' && screenpop_data.label && count<=0) {  
  screenpop_dataehr= screenpop_data?.label+' meditech'
   data = {
    id: screenpop_data?.id,
    label: screenpop_dataehr,
    onClick: () => {
      // handleScreenPop(screenpop_data?.Activityid, ScreenPopFrom.SUBJECT_CARD);
    }
  }
  count +=1

}
if (getEHRProvider() === 'nextgen' && screenpop_data.label && count<=0) {  
  screenpop_dataehr= screenpop_data?.label+' nextgen'
   data = {
    id: screenpop_data?.id,
    label: screenpop_dataehr,
    onClick: () => {
      // handleScreenPop(screenpop_data?.Activityid, ScreenPopFrom.SUBJECT_CARD);
    }
  }
  count +=1

}
      data_array.push(data);
    })
    return data_array;
  }
  /**
   *  This funciton is called from main dashboard quick cards like appoinements,referal,billing,referals and pharmacies
    *  Build dynamic gear dropdown options based on tab settings which are enable and disable
   * @param enabled
   * @param tabnumber
   * @param screenpoptext
   * @param screenpop
   */
  const buildGearActions = (enabled: boolean, tabnumber: string, screenpoptext: string, screenpop: string, from?: ScreenPopFrom) => {
    let gearJson = [];
    let idincr = "1";
    if (enabled) {
      const moredetails = {
        id: idincr,
        label: 'More Details',
        onClick: () => {
          dispatch(setTabAction(tabnumber));
        }
      }
      gearJson.push(moredetails);
      idincr = "2";
    }
    if(screenpop_type === "receive_communication02" && screenpoptext === "Show Guarantor Search in Epic") {
      //Do nothing
    }
    else  {
      if (getEHRProvider() === 'epic' && screenpop_config.screenpop_label) {  
        screenpoptext= screenpoptext+'Epic'
        gearJson.push({
          id: idincr,
          label: screenpoptext,
          onClick: () => {
            handleScreenPop(screenpop, from);
          }
        });
         
    }
    if (getEHRProvider() === 'athena' && screenpop_config.screenpop_label) {  
      screenpoptext= screenpoptext+'Athena'
      gearJson.push({
        id: idincr,
        label: screenpoptext,
        onClick: () => {
          // handleScreenPop(screenpop, from);
        }
      });
       
  }
  if (getEHRProvider() === 'cerner' && screenpop_config.screenpop_label) {  
    screenpoptext= screenpoptext+'Cerner'
    gearJson.push({
      id: idincr,
      label: screenpoptext,
      onClick: () => {
        // handleScreenPop(screenpop, from);
      }
    });
     
}
if (getEHRProvider() === 'meditech' && screenpop_config.screenpop_label) {  
  screenpoptext= screenpoptext+'meditech'
  gearJson.push({
    id: idincr,
    label: screenpoptext,
    onClick: () => {
      // handleScreenPop(screenpop, from);
    }
  });
}
  if (getEHRProvider() === 'nextgen' && screenpop_config.screenpop_label) {  
    screenpoptext= screenpoptext+'nextgen'
    gearJson.push({
      id: idincr,
      label: screenpoptext,
      onClick: () => {
        // handleScreenPop(screenpop, from);
      }
    });
     
  }
}
    

    return gearJson;
  }


   /**
   * Reload the patient information on page reload for Vonage specific agents only
   */
    useEffect(() => {
      if (contact_center_type && contact_center_type === 'vonage') {
        const subjectId = sessionStorage.getItem("subjectid");
        const sourceId = sessionStorage.getItem("sourceid");
        const number = sessionStorage.getItem("ani");
        const dnis = sessionStorage.getItem("dnis");
        const interactionId=sessionStorage.getItem("vonageInteractionId")
  
        let skeleton: {
          source_skeleton: true,
          subject_skeleton: true,
          callingDestination_skeleton: true
        }
        dispatch({
          type: "interact-vonage-set-interaction-id",
          payload: interactionId,
          });
        if (number && dnis && number?.length > 0 && dnis.length > 0) {
          if(consolidated_api_invocation){
            dispatch({
              type: "consolidated-api-one",
              payload: {
                number,
                type: "Patient",
                dnis,
                subjectid: subjectId,
                sourceid: sourceId,
              }
            });
          }else{
            if(epic){
              epic = true;
              athena = false;
              cerner=false;
              nextgen=false;
              meditech=false;
              sessionStorage.setItem('epic', epic.toString());
              sessionStorage.setItem('athena',athena.toString());
              sessionStorage.setItem('cerner',cerner.toString());
              dispatch({
                type: "caller-patient",
                payload: {
                  number,
                  dnis,
                  subjectid: subjectId,
                  sourceid: sourceId,
                  token:tokengen
                }
              });
              dispatch({
                type: "getcallerdetails",
                payload: {
                  number,
                  type: "Patient",
                  sourceid: sourceId,
                }
              });
            }
            else if(athena){
              epic = false;
              athena = true;
              cerner=false;
              nextgen=false;
              meditech=false;
              sessionStorage.setItem('epic', epic.toString());
              sessionStorage.setItem('athena',athena.toString());
              sessionStorage.setItem('cerner',cerner.toString());
              dispatch({
                type: "caller-patient-athena",
                payload: {
                  number,
                  dnis,
                  subjectid: subjectId,
                  sourceid: sourceId,
                  token:tokengen
                }
              });
              dispatch({
                type: "getcallerdetails",
                payload: {
                  number,
                  type: "Patient",
                  sourceid: sourceId,
                }
              });
            }
            else if(cerner){
              epic = false;
              athena = false;
              cerner=true;
              nextgen=false;
              meditech=false;
              sessionStorage.setItem('epic', epic.toString());
              sessionStorage.setItem('athena',athena.toString());
              sessionStorage.setItem('cerner',cerner.toString());
              dispatch({
                type: "caller-patient-cerner",
                payload: {
                  number,
                  dnis,
                  subjectid: subjectId,
                  sourceid: sourceId,
                }
              });
              dispatch({
                type: "getcallerdetails",
                payload: {
                  number,
                  type: "Patient",
                  sourceid: sourceId,
                }
              });
            }
            else if(meditech){
              epic = false;
              athena = false;
              cerner=false;
              nextgen=false;
              meditech=true;
              sessionStorage.setItem('epic', epic.toString());
              sessionStorage.setItem('athena',athena.toString());
              sessionStorage.setItem('cerner',cerner.toString());
              sessionStorage.setItem('meditech',meditech.toString());
              sessionStorage.setItem('nextgen',nextgen.toString());
              dispatch({
                type: "caller-patient-meditech",
                payload: {
                  number,
                  dnis,
                  subjectid: subjectId,
                  sourceid: sourceId,
                }
              });
              dispatch({
                type: "getcallerdetails",
                payload: {
                  number,
                  type: "Patient",
                  sourceid: sourceId,
                }
              });
            }          
             else if(nextgen){
              epic = false;
              athena = false;
              cerner=false;
              meditech=false;
              sessionStorage.setItem('epic', epic.toString());
              sessionStorage.setItem('athena',athena.toString());
              sessionStorage.setItem('cerner',cerner.toString());
              sessionStorage.setItem('meditech',meditech.toString());
              sessionStorage.setItem('nextgen',nextgen.toString());
              dispatch({
                type: "caller-patient-nextgen",
                payload: {
                  number,
                  dnis,
                  subjectid: subjectId,
                  sourceid: sourceId,
                }
              });
              dispatch({
                type: "getcallerdetails",
                payload: {
                  number,
                  type: "Patient",
                  sourceid: sourceId,
                }
              });
            }

         
          }
          dispatch({
            type: "one-state-skeleton/set",
            payload: skeleton
          });
        }
      }
    }, []);
  

  /**
   * Reload the patient information on page reload for Five9 specific agents only
   */
  useEffect(() => {
    if (contact_center_type && contact_center_type === 'five9') {
      const subjectId = sessionStorage.getItem("subjectid");
      const sourceId = sessionStorage.getItem("sourceid");
      const number = sessionStorage.getItem("ani");
      const dnis = sessionStorage.getItem("dnis");

      let skeleton: {
        source_skeleton: true,
        subject_skeleton: true,
        callingDestination_skeleton: true
      }
      if (number && dnis && number?.length > 0 && dnis.length > 0) {
        dispatch({
          type: "one-state-getsession/fetch",
          payload: {
              sessionKey:sourceId ? sourceId.value : null
          }
      });
        dispatch({
          type: "one-state-skeleton/set",
          payload: skeleton
        });
      }
    }
  }, []);

  /**
   * Reload the patient information on page reload for WxCC specific agents only
   */
  useEffect(() => {
    log.debug('contact_center_type::', contact_center_type);
    if (contact_center_type && contact_center_type === 'wxcc' &&
        wxccInteraction?.taskMap && wxccInteraction?.taskMap?.interactionId &&
        wxccInteraction?.taskMap?.interactionId?.length > 0) {

        const wxccReload = () => {
        log.debug('wxccInteraction?.taskMap::', wxccInteraction?.taskMap);
        const subjectId: any = wxccInteraction?.taskMap?.interaction?.callAssociatedData?.subjectId?.value;
        const sourceId: any = wxccInteraction?.taskMap?.interaction?.callAssociatedData?.sourceId?.value;
        const number: any = wxccInteraction?.taskMap?.interaction?.callAssociatedDetails?.ani;
        const dnis: any = wxccInteraction?.taskMap?.interaction?.callAssociatedDetails?.dn;
        const subjectId_session: any = sessionStorage.getItem("subjectid");
        const sourceId_session: any = sessionStorage.getItem("sourceid");
        log.debug('number:dnis', number, dnis);
        let modelVisible: boolean = true;

        let skeleton: any = {
          source_skeleton: true,
          subject_skeleton: true,
          callingDestination_skeleton: true
        }
        if (number && dnis && number?.length > 0 && dnis.length > 0) {
          if ((subjectId && subjectId !== undefined && subjectId !== 'undefined' && subjectId !== null && subjectId?.length > 0)
            || (sourceId && sourceId !== undefined && sourceId !== 'undefined' && sourceId !== null && sourceId?.length > 0)) {
            modelVisible = false;
          } else if ((subjectId_session && subjectId_session !== undefined && subjectId_session !=='undefined' && subjectId_session !== null && subjectId_session !== 'null' && subjectId_session?.length > 0) ||
            (sourceId_session && sourceId_session !== undefined && sourceId_session !=='undefined' && sourceId_session !== null && sourceId_session !== 'null' && sourceId_session?.length > 0)){
              modelVisible = false;
          }
          dispatch({
            type: "one-state-choosecaller/set",
            payload: {
              number: number,
              dnis: dnis,
              visible: modelVisible,
              start: true,
              callId: wxccInteraction?.taskMap?.interactionId
            }
          });
          dispatch({
            type: "one-state-getsession/fetch",
            payload: {
                sessionKey:wxccInteraction?.taskMap?.interactionId
            }
        });
          dispatch({
            type: "one-state-skeleton/set",
            payload: skeleton
          });
        }

      }

      setTimeout(wxccReload, 0)
    }
  }, [wxccInteraction]);

  // To resize to the Finesse Window 
  useEffect(() => {
    try{
        if (contact_center_type && contact_center_type === 'finesse') {
            adjustHeightWithParams(finesse_gadget_height);
        }
      }catch(e){
        console.log('Adjusted Height');
    }
  }, []);

  const handleClickOutsideButton = (event:any) => {
    let target = event.target;
    const searched_text = window.getSelection().toString();
    let userinfo = sessionStorage.getItem('panvivauserinfo')
    const button = document.getElementById("panviva_button");
    let agentIdValue = agentId;
    if (contact_center_type && (contact_center_type === 'five9' || contact_center_type === 'genesys' || contact_center_type === 'inContact')) {
      agentIdValue = sessionStorage.getItem("agentName");
  }
    else if(contact_center_type === "genesys") {
      agentIdValue = sessionStorage.getItem("five9_userid");
    }
    else if(contact_center_type === "twilio") {
      agentIdValue = sessionStorage.getItem("twilio_userid");
    }
    else if (contact_center_type === "intermedia") { // for now setting panviva_sso = false in intermedia
      agentIdValue = userinfo ? userinfo : ""
      if(panviva_sso === true){
        agentIdValue=sessionStorage.getItem("intermedia_uid")
      }
    }
    if(panviva_sso === false) (
      agentIdValue = userinfo ? userinfo : ""
    )
    if (target.tagName === 'BUTTON' && searched_text  && panviva_wordsearch ) { 
    const sobject: PanvivaModel = {
      key:searched_text,
      panviva_id: agentIdValue,
      type: "live_search",
      id: "",
      location: ""
    }
    dispatch(panvivaAction(sobject));
      button.style.display = "none";
      document.removeEventListener('mousedown', handleMouseupEvent);
    }
    else {
      button.style.display = "none";
      document.removeEventListener('mousedown', handleMouseupEvent);
    }
  }

  const handleMouseupEvent = (event: any) => {
    const searched_text = window.getSelection().toString()
    const button = document.getElementById("panviva_button");
    if(panviva_wordsearch && searched_text) {
      button.style.display = "inline-block";
      button.style.position = 'fixed';
      button.style.top = event.clientY + 'px';
      button.style.left = event.clientX + 'px'
      document.removeEventListener('mousedown', handleMouseupEvent);
    }
    else {
      button.style.display = "none";
      document.removeEventListener('mousedown', handleMouseupEvent);
    }
  
  }
  useEffect(() => {
    window.addEventListener("mouseup", handleMouseupEvent);
    return () => {
        window.removeEventListener("mouseup", handleMouseupEvent);
    };
  }, [window.addEventListener]);



  /**
   * Open Five9 Widget (if it is minimized), on a new call arrival
   */

  useEffect(() => {
    //Check whether its a new call
    if(five9InteractionId?.interactionId){
      if(five9InteractionId?.interactionId?.length > 0){
        //Change setWidget to true as it is a new call
        setWidget(true);
      }
    }
  },[five9InteractionId]);




  /**
   * Set Five9 Call Variables on Click To Dial 
   */
  useEffect(() => {
    if(five9InteractionId?.interactionId){
      if(five9InteractionId?.interactionId?.length > 0){
        //Check for click to dial is true
        if(five9ClickToDial?.clicktodial){
          if(five9ClickToDial?.type && five9ClickToDial?.type === 'source'){
            let interactionApi = window.Five9.CrmSdk.interactionApi();
            let interactionId = five9InteractionId?.interactionId;
            interactionApi.getCav({interactionId}).then(function (cavList: any) {
            interactionApi.setCav(
                {
                  interactionId,
                  cavList: [{id: five9_source_id, name: "sourceid", group: "Caller", type: "STRING", value: source?.selected?.id}]
                }).then(function (response: any) {
                  interactionApi.getCav({interactionId}).then(function (cavList: any) {
                })
                })
            })
          }
          if(five9ClickToDial?.type && five9ClickToDial?.type === 'subject'){
            let interactionApi = window.Five9.CrmSdk.interactionApi();
            let crmApi = window.Five9.CrmSdk.crmApi();
            let interactionId = five9InteractionId?.interactionId;
            interactionApi.getCav({interactionId}).then(function (cavList: any) {
            interactionApi.setCav(
                {
                  interactionId,
                  cavList: [{id: five9_subject_id, name: "subjectid", group: "Patient", type: "STRING", value: patients?.selected?.id}]
                }).then(function (response: any) {
                  interactionApi.getCav({interactionId}).then(function (cavList: any) {
                })
                })
            })
            let crmSubjectObject = {id: patients?.selected?.id, label: "Subject", name: patients?.selected?.name, isWho: true, isWhat: false};
            let crmSSNObject = {id: patients?.selected?.ssn, label: "SSN", name: patients?.selected?.ssn, isWho: false, isWhat: true};
            crmApi.objectVisited({crmObject: crmSubjectObject});
            crmApi.objectVisited({crmObject: crmSSNObject});
          }
        }
      }
    }
  }, [five9InteractionId]);


  /**
   * used for screenpop status. as antd notificaiton use hooks internally we are using useeffects
   */
  useEffect(() => {
    if (screenpopstate?.status == 0) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      notification['error']({
        message: screenpopstate.detail ? screenpopstate.detail : "..! Please contact your administrator",
        description: ""
      });

      if (alertnotification?.isEnabled()) {
        let timestamp = new Date().toJSON();
        alertnotification.notify({
          "error_code": "930-31",
          "error_type": "SERVER_ERROR",
          "error_description": "Unable to reach active servers",
          "error_supertype": "SERVER_FAILS",
          "error_detail": "Unable to reach any of server for retring data ",
          "alert": "Yes",
          "timestamp": timestamp,
          "params": ""
        });
      }

    }
    if (screenpopstate?.status) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (screenpopstate?.status == 200) {
        notification['success']({
          message: 'Epic Screen pop successfully initiated.',
          description: "",
        });
      }
      if (screenpopstate?.status == 500) {
        notification['error']({
          message: 'Screen pop to Epic failed because you are not connected to the Snap Adapter. Please connect and try again.',
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          let timestamp1 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "EPIC Screenpop failed",
            "alert": "Yes",
            "timestamp": timestamp1,
            "params": ""
          });
        }
      }
      else if (screenpopstate?.status > 400) {
        notification['error']({
          message: screenpopstate.detail ? screenpopstate.detail : "Oops something isn't quite right..! Please contact your administrator",
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          let timestamp2 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "Epic Screen pop failed due to a server issue",
            "alert": "Yes",
            "timestamp": timestamp2,
            "params": ""
          });
        }
      }

    }
  }, [screenpopstate]);
  //Update Get epic user id
  useEffect(() => {
    if (updateuserdata && contact_center_type !== 'inContact') {
    //Update Get epic user id
    dispatch({
      type: "one-state-getuserid/set",
      payload: {
        agentuserid: updateuserdata?.updateuserid,
        
      }
    });
    }
    
    
    //Check whether its a new call
    if(updateuserdata?.status){
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (updateuserdata?.status == 200) {
        notification['success']({
          message: 'User has been successfully registered',
          description: "",
        });
      }
      else if(updateuserdata?.status > 200) {
        notification['error']({
          message: updateuserdata?.errors[0]?.error_detail,
          description: "",
        });
      }
    }
  },[updateuserdata]);

  useEffect(() => {
        
    //Check whether its a new call
    if(updatepanvivauserdata?.status){
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (updatepanvivauserdata?.status == 200) {
        notification['success']({
          message: 'Success! Panviva user ID successfully registered ',
          description: "",
        });
      }
      else if(updatepanvivauserdata?.status > 200) {
        notification['error']({
          message: 'Oops! There was a problem registering the Panviva user ID. Please try again',
          description: "",
        });
      }
    }
  },[updatepanvivauserdata]);

  // notification handle for call history api
  useEffect(() => {
    if (callHistory?.status) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (callHistory?.status >= 400) {
        notification['error']({
          message: "There seems to be an error. Please hit on the refresh button",
          description: "",
        });
      }
    }
  }, [callHistory]);

  /**
   * used for screenpop status. as antd notificaiton use hooks internally we are using useeffects
   */
  useEffect(() => {
  
    if (receivecommunication?.output?.success == false) {
      let errorarray = receivecommunication?.output?.error;
      errorarray.forEach((errormsg: any) => {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: errormsg.display_text,
          description: ""
        });
      })

      if (alertnotification?.isEnabled()) {
        let timestamp = new Date().toJSON();
        alertnotification.notify({
          "error_code": "930-31",
          "error_type": "SERVER_ERROR",
          "error_description": "Unable to reach active servers",
          "error_supertype": "SERVER_FAILS",
          "error_detail": "Unable to reach any of server for retring data ",
          "alert": "Yes",
          "timestamp": timestamp,
          "params": ""
        });
      }

    }
    if (receivecommunication?.output) {
      let resultarray = receivecommunication?.output?.success;
      if(resultarray === true) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        if (resultarray === true) {
          notification['success']({
            message: 'Epic Screen pop successfully initiated.',
            description: "",
          });
        }
      }
      
      if (receivecommunication?.output?.status == 500) {
        notification['error']({
          message: 'The Screen Pop to Epic Hyperspace failed, please try again. If you continue to experience issues, please contact the support team for assistance.',
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          let timestamp1 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "EPIC Screenpop failed",
            "alert": "Yes",
            "timestamp": timestamp1,
            "params": ""
          });
        }
      }
      else if (receivecommunication?.status > 400) {
        notification['error']({
          message: receivecommunication.detail ? receivecommunication.detail : "Oops something isn't quite right..! Please make sure you logged into Epic Hyperspace",
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          let timestamp2 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "Epic Screen pop failed due to a server issue",
            "alert": "Yes",
            "timestamp": timestamp2,
            "params": ""
          });
        }
      }

    }
    if(receivecommunication?.errors?.length > 0) {
        if (receivecommunication?.status > 400) {
          notification['error']({
            message: receivecommunication.errors[0].display_text ? receivecommunication.errors[0].display_text : "Oops something isn't quite right..! Please make sure you logged into Epic Hyperspace",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            let timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "EPIC_SCREENPOP_ERROR",
              "error_description": "EPIC Screenpop Initiation failed.",
              "error_supertype": "EPIC_SCREENPOP",
              "error_detail": "Epic Screen pop failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
    }
    if(receivecommunication?.type === 'error' && receivecommunication.erroritems?.length > 0){
       if (receivecommunication?.status > 200) {
        notification['error']({
          message: receivecommunication.erroritems[0].display_text ? receivecommunication.erroritems[0].display_text : "Oops something isn't quite right..! Please make sure you logged into Epic Hyperspace",
          description: "",
        });
        //ALERT NOC
        if (alertnotification?.isEnabled()) {
          let timestamp2 = new Date().toJSON();
          alertnotification.notify({
            "error_code": "630-33",
            "error_type": "EPIC_SCREENPOP_ERROR",
            "error_description": "EPIC Screenpop Initiation failed.",
            "error_supertype": "EPIC_SCREENPOP",
            "error_detail": "Epic Screen pop failed due to a server issue",
            "alert": "Yes",
            "timestamp": timestamp2,
            "params": ""
          });
        }
      }
    }
  }, [receivecommunication]);
  /**
   * Used for Panviva status. as antd notificaiton use hooks internally we are using useeffects
   */
  useEffect(() => {
      
    if (panvivauser?.errors?.length > 0) {
      let errorarray = panvivauser?.errors;
      errorarray.forEach((errormsg: any) => {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: "Oops! Couldn't load Panviva content. Please try again.",
          description: ""
        });
      })

      if (alertnotification?.isEnabled()) {
        let timestamp = new Date().toJSON();
        alertnotification.notify({
          "error_code": "930-31",
          "error_type": "SERVER_ERROR",
          "error_description": "Unable to reach active servers",
          "error_supertype": "SERVER_FAILS",
          "error_detail": "Unable to reach any of server for retring data ",
          "alert": "Yes",
          "timestamp": timestamp,
          "params": ""
        });
      }

    }
    if (panvivauser?.output?.success === true) {
      let resultarray = panvivauser?.output?.success;
      if(resultarray === true) {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        if (resultarray === true) {
          notification['success']({
            message: 'Success! Panviva content loaded successfully.',
            description: "",
          });
        }
      }

    }

  }, [panvivauser]);

   //Check error for SN getcustomerdetails
   useEffect(() => {
     
    if(servicenowinfo?.values?.error) {
      servicenowinfo.values.error.erroritems.map((errorinfo:any)=> {
        if (servicenowinfo?.values?.error?.status > 400) {
          notification['error']({
            message: errorinfo.display_text ? errorinfo.display_text : "Oops something isn't quite right..! Please contact your administrator",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            let timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "SN-CustomerDetails Error",
              "error_description": "SN CustomerDetails Initiation failed.",
              "error_supertype": "SN CustomerDetails",
              "error_detail": "SN CustomerDetails failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
      })
    }
  },[servicenowinfo]);
  useEffect(() => {
    if(notesHistory?.error) {
        if (notesHistory?.error?.status > 400) {
          notification['error']({
            message:notesHistory.error.display_text ? notesHistory.error.display_text : "Oops something isn't quite right..! Please contact your administrator",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            alertnotification.notify({
              "error_code":notesHistory?.error?.error_code ,
              "error_type": notesHistory?.error?.error_type,
              "error_description": notesHistory?.error?.error_description,
              "error_supertype": "SN Agent notes",
              "error_detail": notesHistory?.error?.error_detail,
              "alert": "Yes",
              "timestamp": notesHistory?.error?.audit_log?.timestamp,
              "params": ""
            });
          }
        }
    }
  },[notesHistory?.error]);

  //Check for SN createInteractions
  useEffect(() => {
    
    if (createinteractionsdata?.errors?.length > 0) {
      createinteractionsdata.errors.forEach((errorinfo: any) => {
        if (createinteractionsdata?.status > 400) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 3
          });
          notification['error']({
            message: "Failed to create an Interaction",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            let timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "SN-CreateInteractions Error",
              "error_description": "SN CreateInteractions Initiation failed.",
              "error_supertype": "SN CreateInteractions",
              "error_detail": "SN CreateInteractions failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
      })
    }
    else if(createinteractionsdata?.status === 200) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      notification['success']({
        message: 'Interaction has been created successfully.',
        description: "",
      });

    }
  }, [createinteractionsdata]);

  useEffect(() => {
    if (notesHistory?.disableAdd) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      notification['error']({
        message: 'Agent Name is not available',
        description: "",
      });
      dispatch({
        type: 'one-state-notes-history/disableAdd',
        payload: false
      });
    }
  }, [notesHistory?.disableAdd]);

    //Check for SN createIncident
    useEffect(() => {
    
      if (createincidentsdata?.errors?.length > 0) {
        createincidentsdata.errors.forEach((errorinfo: any) => {
          if (createincidentsdata?.status > 400) {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 3
            });
            notification['error']({
              message: "Failed to create an Incident",
              description: "",
            });
            //ALERT NOC
            if (alertnotification?.isEnabled()) {
              let timestamp2 = new Date().toJSON();
              alertnotification.notify({
                "error_code": "630-33",
                "error_type": "SN-CreateInteractions Error",
                "error_description": "SN CreateInteractions Initiation failed.",
                "error_supertype": "SN CreateInteractions",
                "error_detail": "SN CreateInteractions failed due to a server issue",
                "alert": "Yes",
                "timestamp": timestamp2,
                "params": ""
              });
            }
          }
        })
      }
      else if(createincidentsdata?.status === 200) {
        if(createincidentsdata?.output?.results?.length > 0) {
          createincidentsdata.output.results.forEach((incidentinfo:any)=> {
            notification.config({
              placement: "topRight",
              top: 300,
              duration: 3
            });
            notification['success']({
              message: "Incident:"+incidentinfo.number+"is successfully created.",
              description: "",
            });
          })
        }
      }
    }, [createincidentsdata]);

      //Check for SN Update Incidents
      useEffect(() => {
    
        if (updateincidentsdata?.errors?.length > 0) {
          updateincidentsdata.errors.forEach((errorinfo: any) => {
            if (updateincidentsdata?.status > 400) {
              notification.config({
                placement: "topRight",
                top: 300,
                duration: 3
              });
              notification['error']({
                message: "Failed to update Incident",
                description: "",
              });
              //ALERT NOC
              if (alertnotification?.isEnabled()) {
                let timestamp2 = new Date().toJSON();
                alertnotification.notify({
                  "error_code": "630-33",
                  "error_type": "SN-CreateInteractions Error",
                  "error_description": "SN CreateInteractions Initiation failed.",
                  "error_supertype": "SN CreateInteractions",
                  "error_detail": "SN CreateInteractions failed due to a server issue",
                  "alert": "Yes",
                  "timestamp": timestamp2,
                  "params": ""
                });
              }
            }
          })
        }
        else if(updateincidentsdata?.status === 200) {
          if(updateincidentsdata?.output?.results?.length > 0) {
            updateincidentsdata.output.results.forEach((incidentinfo:any)=> {
              notification.config({
                placement: "topRight",
                top: 300,
                duration: 3
              });
              notification['success']({
                message: "Incidentn is successfully updated.",
                description: "",
              });
            })
          }
        }
      }, [updateincidentsdata]);

  //Check for SN LinkExistingIncident
  useEffect(() => {
    if (linkedincidentdata?.errors?.length > 0) {
      linkedincidentdata.errors.forEach((errorinfo: any) => {
        if (linkedincidentdata?.status > 400) {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 3
          });
          notification['error']({
            message: "Failed to link an Incident",
            description: "",
          });
          //ALERT NOC
          if (alertnotification?.isEnabled()) {
            let timestamp2 = new Date().toJSON();
            alertnotification.notify({
              "error_code": "630-33",
              "error_type": "SN-LinkIncidents Error",
              "error_description": "SN LinkIncidents Initiation failed.",
              "error_supertype": "SN LinkIncidents",
              "error_detail": "SN LinkIncidents failed due to a server issue",
              "alert": "Yes",
              "timestamp": timestamp2,
              "params": ""
            });
          }
        }
      })
    }
    else if(linkedincidentdata?.status === 200) {
      if(linkedincidentdata?.output?.results?.length > 0) {
        linkedincidentdata.output.results.forEach((incidentinfo:any)=> {
          notification.config({
            placement: "topRight",
            top: 300,
            duration: 3
          });
          notification['success']({
            message: "Incident is linked successfully.",
            description: "",
          });
        })
      }
    }
  }, [linkedincidentdata]);

  // check for the allergies and active problems
  useEffect(() => {
    if (allergiesstate?.length > 0) {
      setActiveAllergy(allergiesstate[0].allergenName);
    } else {
      setActiveAllergy(null);
    }
  }, [allergiesstate]);

  useEffect(() => {
    if (activeproblems?.length > 0) {
      setActiveProblem(activeproblems[0].problemName)
    } else {
      setActiveProblem(null);
    }
  }, [activeproblems]);

  /**
   * Show notification for addnew record status
   */

  useEffect(() => {
    if (addnew.notification) {
      notification.config({
        placement: "topRight",
        top: 300,
        duration: 3
      });
      if (addnew.notificationmsg === 'Record Inserted Successfully.') {
        notification['success']({
          message: addnew.notificationmsg,
          description: "",
        });
      }
      if (addnew.notificationmsg === 'Caller record was not successfully created.') {
        notification['error']({
          message: addnew.notificationmsg,
          description: "",
        });
      }

    }
  }, [addnew]);

  /**
   * Show notification for Cancel Appointment
   */

  useEffect(() => {
    if (apptstable?.cancelmsg?.length>=0) {
      let apptcode = apptstable.apptcode;
      let cancelmsg = apptstable.cancelmsg;
      if (apptcode === '1') {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['success']({
          message: 'Alert',
          description: cancelmsg,
        });
      } else {
        notification.config({
          placement: "topRight",
          top: 300,
          duration: 3
        });
        notification['error']({
          message: 'Alert',
          description: cancelmsg,
        });
             //making skeleton display before cancelmsg
             dispatch ({
              type: "one-state-skeleton/set",
              payload:{
                  upcomingAppts_skeleton: false,
              }
          })
      }
      dispatch(
        {
          type: "one-state-appointments/reset-cancel-appt-notification",
          payload: {
            cancelmsg: null,
            apptcode: '0'
          }
        }
      )
      if (apptcode === '1' || apptstable[0]?.issue) {
        setTimeout(() => {
          if(epic) {
            dispatch(
              {
                type: "set-appointments-success",
                payload: patients.selected
              }
            )
          }
          else if(athena) {
            dispatch(
              {
                type: "set-appointments-success-athena",
                payload: patients.selected
              }
            )
          }
          else if(meditech) {
            dispatch(
              {
                type: "set-appointments-success-meditech",
                payload: patients.selected
              }
            )
          }
        }, 1000);
      }
    }
  }, [apptstable]);
  /**
   * identify the caller is provider or patient based on the based state returned
   */
  let patientvaluecount = 0, providervaluecount = 0;
  if (source) {
    const sourcedata = source.values;
    sourcedata.forEach((countvalue: any) => {
      if ((countvalue?.typename) === "Patient") {
        patientvaluecount = patientvaluecount + 1;
      }
      if ((countvalue?.typename) === "Provider") {
        providervaluecount = providervaluecount + 1;
      }
    })
  }

  let dashboardTabWithTimeLine = (
    <Row gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
      <Col span={16}>
        <Row gutter={[16, 16]}>
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
              <Row gutter={[16, 16]}>
                <Col span={24}>
                  <UpcomingAppointmentCard
                    className="box"
                    title="Appointments"
                    gearActions={buildGearActions(tabconfig.appointments, '2', 'Show Appointments in ', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
                    model={upappts}
                    skeleton={skeleton} />
                </Col>
                {getEHRProvider()==='nextgen'&&(
                  <>
                  {/* <Col span={24}>
                  <UpcomingAppointmentCard
                    className="box"
                    title="Financial"
                    gearActions={buildGearActions(tabconfig.appointments, '6', 'Show Billing in ', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
                    model={upappts}
                    skeleton={skeleton} />
                </Col> */}
                <Col span={24}>
                  <UpcomingAppointmentCard
                    className="box"
                    title="Alerts"
                    gearActions={buildGearActions(tabconfig.appointments, '7', 'Show Appointments in ', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
                    model={{

                    }}
                    skeleton={skeleton} />
                </Col>
                  </>
                )}
                <Col span={24}>

                  {sessionStorage.getItem('ehr')==='cerner'?
                  <PendingBillsCardCerner
                    title="Financial"
                    gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingbillscerner}
                    billing={billingdetailscerner}
                    skeleton={skeleton} />:null}

                    {sessionStorage.getItem('ehr')==='athena'?
                    <PendingBillsCardAthena
                    title="Billing Information"
                    gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingb}
                    billing={billingdetails}
                    skeleton={skeleton} />:null}
                    {sessionStorage.getItem('ehr')==='epic'?
                    <PendingBillsCard
                    title="Financial"
                    gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingb}
                    billing={billingdetails}
                    skeleton={skeleton} />:null
                    }
                </Col>
                <Col span={24}>
                {sessionStorage.getItem('ehr')!=='nextgen'&& (<InsuranceCard className='mb-10' title="Insurance" skeleton={skeleton} insurance={insurancedetails} />)}
                </Col>
              </Row>
          </Col>
          <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
            <Row gutter={[16, 16]}>
            {sessionStorage.getItem('ehr')!=='nextgen'&&  (<Col span={24}>
                <PendingReferalsCard
                  className="box box-theme2"
                  title="Referrals"
                  gearActions={buildGearActions(tabconfig.referals, '3', 'Show Referrals in ', referraldesk, ScreenPopFrom.DASHBOARD_TAB)}
                  model={referrals}
                  colorschema={['#7982B9', '#A5C1DC', '#E9F6FA', '#6050DC']}
                  skeleton={skeleton} />
              </Col>)}
              <Col span={24}>
                {getEHRProvider() === 'cerner' && (
                <PharmaciesCard
                  title="Pharmacies"
                  gearActions={buildGearActions(false , '6', 'Show Pharmacies In ', pharmacy, ScreenPopFrom.DASHBOARD_TAB)}
                  model={{
                    pharmacydata: pharmacies,
                  }}
                  skeleton={skeleton}
                />)}
              </Col>
              <Col span={24}>
              {sessionStorage.getItem('ehr')!=='nextgen'&& ( <PatientAdditionalInfoCard
                  model={{
                    subjects: patients.values,
                    selected: patients.selected,
                    pcpdata: pcpstate,
                    pharmacydata: pharmacies,
                  }}
                  skeleton={skeleton} /> )} 
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                md={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                span={contact_center_type && contact_center_type === 'finesse' ? 24 : null}>
              {dashboardtab.map && (
                <MapCard
                  address={patients.selected?.address}
                  calldest={entity}
                  pharmacies={Object.keys(pharmacies).map((key) => pharmacies[key])}
                  callerNumber={choosecaller?.number || ''} />
              )}
          </Col>
        </Row>
      </Col>
      <Col span={8}>
        <UserTimeline />
      </Col>
    </Row>
  );

  let dashboardTabWithoutTimeLine = (
    <>
        <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
          {
            
            <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
                md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
                span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
              <UpcomingAppointmentCard
                className="box"
                title="Appointments"
                gearActions={buildGearActions(tabconfig.appointments, '2', 'Show Appointments in ', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
                model={upappts}
                skeleton={skeleton}
              />
            </Col>
          }
          {getEHRProvider()==='nextgen'&&(
                  <>
{/* <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
                md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
                span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>                  <UpcomingAppointmentCard
                    className="box"
                    title="Financial"
                    gearActions={buildGearActions(tabconfig.appointments, '6', 'Show Billing in ', apptdesk, ScreenPopFrom.DASHBOARD_TAB)}
                    model={upappts}
                    skeleton={skeleton} />
                </Col> */}
                <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
                md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
                span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}> 
                 <AlertsSummaryCard
                    className="box"
                    title="Alerts"
                    gearActions={buildGearActions(tabconfig.alerts, '4', 'Show Referrals in ', referraldesk,ScreenPopFrom.DASHBOARD_TAB)}
                    model={{
                      alerts: alertnextgen
                    }}
                 />
                </Col>
                  </>
                )}
          {getEHRProvider()!=='nextgen'&&

            
            (<Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
                md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
                span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}> 
              <PendingReferalsCard
                className="box box-theme2"
                title="Pending Referrals"
                gearActions={buildGearActions(tabconfig.referals, '3', 'Show Referrals in ', referraldesk,ScreenPopFrom.DASHBOARD_TAB)}
                model={referrals}
                colorschema={['#7982B9', '#A5C1DC', '#E9F6FA', '#6050DC']}
                skeleton={skeleton}
              />
            </Col>)
          }
          {sessionStorage.getItem('ehr') !== 'nextgen' && (
            
            <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
            sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
            md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
            span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
          {sessionStorage.getItem('ehr')==='cerner'?
                  <PendingBillsCardCerner
                    title="Billing Information"
                    gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingbillscerner}
                    billing={billingdetailscerner}
                    skeleton={skeleton} />:null}

                    {sessionStorage.getItem('ehr')==='athena'?
                    <PendingBillsCardAthena
                    title="Billing Information"
                    gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingb}
                    billing={billingdetails}
                    skeleton={skeleton} />:null}
                    {sessionStorage.getItem('ehr')==='epic'?
                    <PendingBillsCard
                    title="Billing Information"
                    gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                    model={pendingb}
                    billing={billingdetails}
                    skeleton={skeleton} />:null
                    }
        </Col>
          )}
          {sessionStorage.getItem('ehr') === 'nextgen' && (
            
            <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
            sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
            md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
            span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
                <PendingBillsCard
                title="Financial"
                gearActions={buildGearActions(tabconfig.billing, '5', 'Show Guarantor Search in ', pendingbills, ScreenPopFrom.DASHBOARD_TAB)}
                model={pendingb}
                billing={billingdetails}
                skeleton={skeleton} />
        </Col>
          )}
            {(getEHRProvider() === 'athena' || getEHRProvider() === 'cerner') && (
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
              span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
              <PatientCareProviderCardEHR title="Patient Care Team" model={{
                pcpdata:pcpstate
              }} skeleton={skeleton} />
              </Col>
            )}
            {(getEHRProvider() === 'epic' || getEHRProvider() === 'meditech') && (
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24}
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12} 
              md={contact_center_type && contact_center_type === 'finesse' ? null : 6}
              span={contact_center_type && contact_center_type === 'finesse' ? 6 : null}>
                <PatientCareProviderCard title="Patient Care Team" model={{
                pcpdata:pcpstate
              }} skeleton={skeleton} />
               </Col>
            )}
        </Row>
        <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 64 : { xs: 16, sm: 16, md: 64 }]}>
          <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
               md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
               span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
            <Row type="flex" gutter={[16, 16]}>
            <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
          sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
          span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
        <EmergencyContactCard
          title = 'Emergency Contact'
          model={{
            subjects: patients.values,
            selected: patients.selected
          }}
        />
      </Col>
        {(getEHRProvider() === 'epic' || getEHRProvider() === 'cerner' || getEHRProvider() === 'meditech') && (
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                <EmploymentInfoCard
                  title="Employment Information"
                  model={{
                    subjects: patients.values,
                    selected: patients.selected,
                  }}
                />
              </Col>
            )}
            {(getEHRProvider() === 'athena') && (
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
              sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
              span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
            <EmploymentInfoCardAthena
              title="Employment Information"
              model={insurancedetails}
            />
          </Col>
            )}
              {getEHRProvider()!=='nextgen' && (

                <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                     sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                     span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                  <PharmaciesCard
                    title="Pharmacies"
                    gearActions={buildGearActions(false , '6', 'Show Pharmacies In ', pharmacy,ScreenPopFrom.DASHBOARD_TAB)}
                    model={{
                      pharmacydata: pharmacies,
                    }}
                    skeleton={skeleton}
                  />
                </Col>
              )}
        {(getEHRProvider() === 'epic' || getEHRProvider() === 'cerner' || getEHRProvider() === 'meditech' || getEHRProvider() === 'nextgen') && (
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                <InsuranceCard title="Insurance" skeleton={skeleton} insurance={insurancedetails} />
              </Col>
            )}
            {(getEHRProvider() === 'athena') && (
              <Col xs={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                  sm={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                  span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                  <InsuranceCardAthena title="Insurance" skeleton={skeleton} insurance={insurancedetails} />
              </Col>
            )}
            </Row>
            {/* <Row type="flex" gutter={[16, 32]}>
              <Col span={24}>
                <InsuranceCard
                  title="Insurance"
                  skeleton={skeleton}
                  insurance={insurancedetails}
                />
              </Col>
            </Row> */}
            {/* <Row type="flex" gutter={[16, 32]}>
              <Col span={24}>
                <InsuranceCardNew
                  title="Insurance"
                  skeleton={skeleton}
                  fhirstate={fhirdata}
                />
              </Col>
            </Row> */}
          </Col>
          <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
               md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
               span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
            <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]} style={{height:"105%"}}>
              <Col span={24}>
              {(dashboardtab.map &&  getEHRProvider()!=='nextgen' )&& 
(
                  <MapCard
                    title="Find Location"
                    address={patients.selected?.address}
                    calldest={entity}
                    pharmacies={Object.keys(pharmacies).map((key) => pharmacies[key])}
                    callerNumber={choosecaller?.number || ''}
                  />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
    </>
  );

  useEffect(()=>{
    
    if(patients?.selected){
      let agentId="";
      let teamName="";
      let dispvalue = "";
      let tabmessage="";

      if(activetab === "1") {
        tabmessage = "Clicked on the Dashboard Tab"
        dispvalue = "2026"
      }
      else if(activetab === "2") {
        tabmessage = "Clicked on the Appointment Tab"
        dispvalue = "2027"
      }
      else if(activetab === "3") {
        tabmessage = "Clicked on the Referrals Tab"
        dispvalue = "2028"
      }
      else if(activetab === "4") {
        tabmessage = "Clicked on the Medical History Tab"
        dispvalue = "2029"
      }
      else if(activetab === "5") {
        tabmessage = "Clicked on the Billing Tab"
        dispvalue = "2030"
      }
      else if(activetab === "7") {
        tabmessage = "Clicked on the Prescription Tab"
        dispvalue = "2031"
      } 
      else if(activetab === "8") {
        tabmessage = "Clicked on the Medication Tab"
        dispvalue = "2032"
      } 
      //Dispostion for call controls
          let disp: Disposition = { value: dispvalue }
          if(contact_center_type==="finesse"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = agentId;
            disp.meta01 = teamName;
          }
          else if(contact_center_type==="five9"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = sessionStorage.getItem("agentName");
            disp.meta01 = sessionStorage.getItem("skillName");
          }
          else if(contact_center_type==="genesys"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = sessionStorage.getItem("name");
            disp.meta01 = sessionStorage.getItem("agentName");
          }
          else if(contact_center_type==="twilio"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = paramTwilioAgentName;
            disp.meta01 = "";
          }
          else if(contact_center_type==="ringcentral"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = sessionStorage.getItem("ringcentral_agentName");
            disp.meta01 = "";
          }
          else if(contact_center_type==="inContact"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = paramInContactAgentName;
            disp.meta01 = paramInContactSkillName;
          }
          else if(contact_center_type==="vonage"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = sessionStorage.getItem("vonage_userid");
            disp.meta01 = "";
          }
          else if(contact_center_type==="wxcc"){
            disp.dial_list_uid = choosecaller?.callId;
            disp.meta00 = sessionStorage.getItem("wxcc_agentId");
            disp.meta01 = "";
          }
          disp.meta02 = tabmessage;
          dispatch({
            type: "store-disposition-code",
            payload: disp
          });
    }
  },[activetab])


  
  /**
   * Build dashboard based on caller is patient or provider
   * For Patient --Tabs and  Patient Dashboard are shown
   * For Provider -- No tabs ,just new call log with number of matches
   */
  let patientdashboard = (
    <Tabs
      type="line"
      defaultActiveKey="1"
      activeKey={(patients.values || patients.selected) ? activetab : "13"}
      onChange={(activeKey) => dispatch(setTabAction(activeKey))}
    >
      {
        (patients.values || patients.selected || subjectdemo?.id) && (
      <TabPane tab="Dashboard" key="1">
        {timeline ? dashboardTabWithTimeLine : dashboardTabWithoutTimeLine}
      </TabPane>
      )
    }
      {((tabconfig.appointments && 
        checkRole(auth, 'tab/appointments', teamName) && 
        (patients.values || patients.selected)  && 
        (getEHRProvider() === 'epic' || getEHRProvider() === 'meditech')) && (
        <TabPane tab="Appointments" key="2">
          <AppointmentCard
            title=""
            appointmentType={[
              {
                id: 'future',
                label: 'Future',
              },
              {
                id: 'past',
                label: 'Past',
              },
              {
                id: 'canceled',
                label: 'Canceled',
              },
              {
                id: 'noshows',
                label: 'No Shows',
              },
            ]}
            useridType={useridtype}
            model={apptstable}
            patientInfo={{
              phone: patients.selected?.contact_formatted,
              address: patients.selected?.address
            }}
            canConfirmAppointment={confirmappointment}
            canUpdateappointment={updateappointment}
            onAppointmentTypeChange={(value: any) => {
              dispatch(addAppointmentType({ appointmentSelectedType: value }));
            }}
            onCancelAppointment={(value: any) => {
              if(getEHRProvider() === 'cerner'){
                dispatch({
                  type: 'one-state-appointments/cancel-appt-cerner',
                  payload: value,
                });
              }
              else if(getEHRProvider() === "epic"){
                dispatch({
                  type: 'one-state-appointments/cancel-appt',
                  payload: value,
                });
              }
              else if(getEHRProvider() === "meditech"){
                dispatch({
                  type: 'one-state-appointments/cancel-appt-meditech',
                  payload: value,
                });
              }
            }}
            
            onConfirmAppointment={(value: any) => {
              if(getEHRProvider() === "epic"){
                dispatch({
                  type: 'one-state-appointments/confirm-appt',
                  payload: value,
                })
              }
              if(getEHRProvider() === "meditech"){
                dispatch({
                  type: 'one-state-appointments/confirm-appt-meditech',
                  payload: value,
                })
              }
            }}
            onUpdateAppointment={(value: any) => {
              dispatch({
                type: 'one-state-appointments/update-appt',
                payload: value,
              });
            }}
            onAppointmentScreenpopChange={(value: any) => {
              handleScreenPop(apptdesk, ScreenPopFrom.APPOINTMENTS_TAB);
            }}
      />
    </TabPane>
  ))}
        {((tabconfig.appointments && 
    checkRole(auth, 'tab/appointments', teamName) && 
    (patients.values || patients.selected)  && 
    (getEHRProvider() === 'nextgen')) && (
    <TabPane tab="Appointments" key="2">
      <AppointmentCardNextgen
        title=""
        appointmentType={[
          {
            id: 'future',
            label: 'Future',
          },
          {
            id: 'past',
            label: 'Past',
          },
          {
            id: 'canceled',
            label: 'Canceled',
          },
          {
            id: 'noshows',
            label: 'No Shows',
          },
        ]}
        useridType={useridtype}
        model={apptstable}
        patientInfo={{
          phone: patients.selected?.contact_formatted,
          address: patients.selected?.address
        }}
        canConfirmAppointment={confirmappointment}
        canUpdateappointment={updateappointment}
        onAppointmentTypeChange={(value: any) => {
          dispatch(addAppointmentType({ appointmentSelectedType: value }));
        }}
      />
    </TabPane>
      ))}
      {tabconfig.appointments && 
        checkRole(auth, 'tab/appointments', teamName) && 
        (patients.values || patients.selected) && 
        (getEHRProvider() === 'cerner') && (
        <TabPane tab="Appointments" key="2">
          <AppointmentCardCerner
            title=""
            appointmentType={[
              {
                id: 'future',
                label: 'Future',
              },
              {
                id: 'past',
                label: 'Past',
              },
              {
                id: 'canceled',
                label: 'Canceled',
              },
              {
                id: 'noshows',
                label: 'No Shows',
              },
            ]}
            useridType={useridtype}
            model={apptstable}
            patientInfo={{
              phone: patients.selected?.contact_formatted,
              address: patients.selected?.address
            }}
            canConfirmAppointment={confirmappointment}
            canUpdateappointment={updateappointment}
            onAppointmentTypeChange={(value: any) => {
              dispatch(addAppointmentType({ appointmentSelectedType: value }));
            }}
            onCancelAppointment={(value: any) => {
              dispatch({
                type: 'one-state-appointments/cancel-appt-cerner',
                payload: value,
              });
            }}
            onConfirmAppointment={(value: any) => {
              if(getEHRProvider() === 'athena'){
                dispatch({
                  type: 'one-state-appointments/confirm-appt-athena',
                  payload: value,
                })
              }
              else if(getEHRProvider() === "epic"){
                dispatch({
                  type: 'one-state-appointments/confirm-appt',
                  payload: value,
                })
              }
            }}
            onAppointmentScreenpopChange={(value: any) => {
              handleScreenPop(apptdesk, ScreenPopFrom.APPOINTMENTS_TAB);
            }}
          />
        </TabPane>
      )}
      {tabconfig.appointments && 
        checkRole(auth, 'tab/appointments', teamName) && 
        (patients.values || patients.selected) && 
        (getEHRProvider() === 'athena') && (
        <TabPane tab="Appointments" key="2">
          <AppointmentCardAthena
            title=""
            appointmentType={[
              {
                id: 'future',
                label: 'Future',
              },
              {
                id: 'past',
                label: 'Past',
              },
              {
                id: 'canceled',
                label: 'Canceled',
              },
              {
                id: 'noshows',
                label: 'No Shows',
              },
            ]}
            useridType={useridtype}
            model={apptstable}
            patientInfo={{
              phone: patients.selected?.contact_formatted,
              address: patients.selected?.address
            }}
            canConfirmAppointment={confirmappointment}
            canUpdateappointment={updateappointment}
            canRescheduleAppointment={rescheduleappointment?.enabled}
            onAppointmentTypeChange={(value: any) => {
              dispatch(addAppointmentType({ appointmentSelectedType: value }));
            }}
            onCancelAppointment={(value: any) => {
              dispatch({
                type: 'one-state-appointments/cancel-appt-athena',
                payload: value,
              });
            }}
            onConfirmAppointment={(value: any) => {
              if(getEHRProvider() === 'athena'){
                dispatch({
                  type: 'one-state-appointments/confirm-appt-athena',
                  payload: value,
                })
              }
              else if(getEHRProvider() === "epic"){
                dispatch({
                  type: 'one-state-appointments/confirm-appt',
                  payload: value,
                })
              }
            }}
            onAppointmentScreenpopChange={(value: any) => {
              handleScreenPop(apptdesk, ScreenPopFrom.APPOINTMENTS_TAB);
            }}
          />
        </TabPane>
      )}
      {tabconfig.referals && checkRole(auth, 'tab/referrals', teamName) && (patients.values || patients.selected) && getEHRProvider() !== 'nextgen' && (
          <TabPane tab={sessionStorage.getItem('ehr')==='cerner'?"Orders":"Referrals"} key="3">
          <ReferralsTab
            title="Referal"
            colorschema={[]}
            gearActions={[]}
            model={referrals}
            handleMenuClick={() => {
              handleScreenPop(referraldesk, ScreenPopFrom.REFERRALS_TAB);
            }}
            />
          </TabPane>)
        }
      {tabconfig.financial && 
        checkRole(auth, 'tab/billing', teamName) && 
        (patients.values || patients.selected) && 
        (getEHRProvider() === 'nextgen') && (
        <TabPane tab="Financial" key="3">
          <BillingCard
             title="Outstanding Account"
            billing={billingdetails}
            onAccountChange={(accountevent: any) => {
              dispatch(selectBillingAction(accountevent));
            }}
            onPaymentChange={(billpayment: boolean) => {
              dispatch(setBillingPaymentAction(billpayment));
            }}
          />
        </TabPane>
                     )}
      {tabconfig.alerts && 
        checkRole(auth, 'tab/alerts', teamName) && 
        (patients.values || patients.selected) && 
        (getEHRProvider() === 'nextgen') && (
        <TabPane tab="Alerts" key="4">
          <AlertsCard
            className="box"
            title="Alerts"
            model={{
              alerts: alertnextgen
            }}
          />
        </TabPane>
                     )}

{tabconfig.triage && checkRole(auth, 'tab/triage', teamName) && (patients.values || patients.selected) && (
        <TabPane tab="Medical History" key={getEHRProvider() !== 'nextgen' ? "4" : "5"}>
          <Row type="flex" gutter={[16, 32]}>
            {
              (
              <Col span={12}>
                <ActiveProblemsCard
                  title={cerner ? 'Procedure List' : 'Active Problems'}
                  model={{
                    activeproblems: activeproblems,
                  }}
                />
              </Col>
            )}
            {
              (
              <Col span={12}>
                <MedicalHistoryCard
                  title="Medical History"
                  model={{
                    medicalhistory: medicalhistory,
                  }}
                />
              </Col>
            )}
          </Row>
          <Row type="flex" gutter={[16, 32]}>
            {
              (
              <Col span={24}>
                <ActiveAlleriesCard
                  title="Active Allergies"
                  model={{
                    allergies: allergiesstate,
                  }}
                />
              </Col>
            )}
          </Row>
        </TabPane>
      )}
      
      {tabconfig.billing && checkRole(auth, 'tab/billing', teamName) && (patients.values || patients.selected) && getEHRProvider() !== 'nextgen' && (
        <TabPane tab="Billing" key="5">
          {getEHRProvider()==='cerner'?
          <BillingCardCerner
          title="Outstanding Account"
          billing={billingdetailscerner}
          PatientID={patients?.selected?.id}
            onAccountChange={(accountevent: any) => {
              dispatch(selectBillingAction(accountevent));
            }}
            onPaymentChange={(billpayment: boolean) => {
              dispatch(setBillingPaymentAction(billpayment));
            }}
            skeleton={skeleton}
        />:null}
          {getEHRProvider()==='athena'?
          <BillingCardAthena
            title="Outstanding Accounts"
            billing={billingdetailsathena}
            onAccountChange={(accountevent: any) => {
              dispatch(selectBillingAction(accountevent));
            }}
            onPaymentChange={(billpayment: boolean) => {
              dispatch(setBillingPaymentAction(billpayment));
            }}
          />:null}
          {getEHRProvider()==='epic' && getEHRProvider()!=='athena'&& getEHRProvider()!=='cerner'?
          <BillingCard
            title="Outstanding Account"
            billing={billingdetails}
            onAccountChange={(accountevent: any) => {
              dispatch(selectBillingAction(accountevent));
            }}
            onPaymentChange={(billpayment: boolean) => {
              dispatch(setBillingPaymentAction(billpayment));
            }}
          />:null}
        </TabPane>
      )}
      

{tabconfig.prescription  && (patients.values || patients.selected) && (getEHRProvider() === 'epic') && (
        <TabPane tab="Prescription" key="7">
          <PrescriptionTab
            title="Prescription"
            model={{
              prescriptiondata: prescription,
            }}
            onRefillScreenpopChange={(value: any) => {
              handleScreenPop(refilldesk);
            }}
          /> 
        </TabPane>
      )}
      {tabconfig.prescription  && (patients.values || patients.selected)&& (getEHRProvider() === 'athena' || getEHRProvider() === 'cerner') && (
        <TabPane tab="Prescription" key="7">
          <PrescriptionEHRTab
            title="Prescription"
            model={{
              prescriptiondata: prescription,
            }}
          />
        </TabPane>
      )}
      {tabconfig.medication && checkRole(auth, 'tab/medication', teamName) && (patients.values || patients.selected) && (
        <TabPane tab="Medication" key="8">
          <MedicationCard
            model={{
              medication: medication,
            }}
          />
        </TabPane>
      )}
      {tabconfig.orders && (patients.values || patients.selected) && (
        <TabPane tab="Orders" key="9">
          <OrderTabCard
            model={{
              orderdata: orderstabdata?.orderdata,
            }}
          />
        </TabPane>
      )}

      {/* <TabPane tab="Schedule" key="7">
      </TabPane> */}
      {/*<TabPane tab="Location" key="8">
        </TabPane>*/}
      {tabconfig.cleartriage  && (patients.values || patients.selected) && (
        <TabPane tab="ClearTriage" key="10">
        <Row type="flex" gutter={[16, 32]}>
          <Col span={24}>
            <ClearTriage />
          </Col>
        </Row>
      </TabPane>
      )}   
      {tabconfig.servicenow  && (patients.values || patients.selected) && (
        <TabPane tab="ServiceNow" key="11">
          <Layout>
            <Row type="flex" gutter={[16, 32]}>
              <Col span={24}>
              <ServiceNowCallerCard
              title='ServiceNow'
              model={{
                servicenowcaller: servicenowinfo
              }}
              skeleton={skeleton}
              />
              </Col>
              <Col span={24}>
                <Tabs
                  defaultActiveKey={tabs}
                  activeKey={tabs}
                  onTabClick={(event: any) => {
                    setTabs(event)}}
                  type="line"
                  tabBarStyle={{ fontSize: '18px' }}
                >
                  <TabPane
                    tab={<span>Call Record</span>}
                    key="1"
                  >
                    <CallRecord/>
                  </TabPane>
                  <TabPane
                    tab={<span>Incidents</span>}
                    key="2"
                  >
                    <IncidentsCard 
                    title='Incidents'
                    model={{
                      data: incidentsinfo.callerincidentdata
                    }}
                    />
                  </TabPane>
                  <TabPane
                    tab={<span>Interactions</span>}
                    key="3"
                  >
                    <InteractionsCard
                    title=''
                    model={{
                      data:interactionsinfo.callerinteractiondata
                    }}
                    />
                  </TabPane>
                </Tabs>
              </Col>
            </Row>
          </Layout>
        </TabPane>
      )}
      {tabconfig.callhistory && (
        <TabPane tab="Call History" key="12">
          <CallHistoryTab />
        </TabPane>
      )}
    </Tabs>
  );

  // show only Phone Image on initial screen/ reset
  let dashboard = (
    <NoCall ani={choosecaller?.number} />
  )
  //Checking for Initial Epic User Id
  let epicsuserdata = (
    <>
    {(screenpop_type === 'receive_communication' || screenpop_type === 'receive_communication02' || screenpop_type === 'receive_communication03') && (epicuserid?.agentuserid === "") && (sso === false) && (
      <NewUserIdModalCard
      model = {{
        epicuserdata : epicuserid
        }}
      />
    )}
    </>
  )
  //check for the Selected Type
  if (sourceType.selected) {
    let callertype = sourceType.selected?.label;
    // Selected call is Patient
    if (callertype === "Patient") {
      if (patients?.values?.length == 0 &&
        patients?.selected === undefined && getsessionresp?.length === 0) {
        dashboard = (
          <NoMatchCall type="Patient" />
        )
      }
      // Verify Patient ICON to be displayed No patient selected
      else if (patients?.values?.length > 0 &&
         (!subjectdemo?.id)) {
        dashboard = (
          <PatientVerify onClick={() => {
            dispatch({
              type: "one-state-choosecaller/set",
              payload: {
                number: choosecaller.number,
                dnis: choosecaller.dnis,
                visible: true,
                start: false
              }
            });
          }} />
        )
      }
      // Display Patient Dashboard
      else if (patients?.values?.length > 0 &&
        subjectdemo?.id !== undefined) {
        dashboard = patientdashboard;
      }

    }
    // Selected call is Provider
    if (callertype === "Provider") {
      // NoMatch Provider Call
      if (source?.values?.length == 0 &&
        source?.selected === undefined && getsessionresp?.length === 0) {
        dashboard = (
          <NoMatchCall type="Provider" />
        )
      }
      // Only Provider
      else if ((providervaluecount > 0 &&
        skeleton.subject_skeleton === false)) {
        dashboard = (
          <ProviderMatch count={providervaluecount} ani={choosecaller?.number} />
        )
      }
      // Display dashboard  if patient selected from the search
      if (patients?.values?.length > 0 &&
        subjectdemo?.id !== undefined) {
        dashboard = patientdashboard;
      }
      else if(subjectdemo) {
        dashboard = patientdashboard;
      }
    }

  } else {
    // considering as no active call.
    if (patients?.values === undefined && source?.values.length == 0) {
      dashboard = (
        <NoCall ani={choosecaller?.number} />
      )
    }
    // No Active call but Display dashboard if patient selected from the global search
    if (patients?.values?.length > 0 &&
      subjectdemo?.id !== undefined) {
      dashboard = patientdashboard;
    }
    //showing only caller history tab after successful login to five9
    if (five9Store?.globalsearch || sessionStorage.getItem("five9_globalsearch") === "true") {
      dashboard = patientdashboard;
    }
  }

  const callFive9Logout = (e: any) => {
    log.debug('Inside Logout,', e?.key);
    let five9_userid = sessionStorage.getItem("five9_userid");
    // Sanitize five9_userid and payload to prevent command injection
    const sanitizedUserId = five9_userid ? five9_userid.replace(/[^a-zA-Z0-9_-]/g, '') : '';
    const sanitizedKey = e?.key ? e.key.replace(/[^a-zA-Z0-9_-]/g, '') : '';
    interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/agents/${sanitizedUserId}/session_stop?force=true`, method: 'PUT', payload: `{"id":"${sanitizedKey}"}` }).then(function (result: any) {
      log.debug('Session Stop Executed,', result);
      // resolve handler
      const { status } = result
      log.debug('Session Stop Response Result,', status);
      if(status == 204){
        interactionApi.executeRestApi({ path: `/appsvcs/rs/svc/auth/logout`, method: 'POST', payload: null }).then(function (result: any) {
          log.debug('Logout Executed,', result);
          // resolve handler
          const { status } = result
          log.debug('Logout Result,', status);
          if(status == 204){
            dispatch({
                type: "one-state-subject/reset",
                payload: {
                    number: '',
                    dnis: ''
                }
            });
  
            dispatch({
                type: "one-state-choosecaller/reset",
                payload: {
                    number: '',
                    dnis: '',
                    visible: false,
                    start: false
                }
            });
            dispatch({
                type: "one-state-tabs/set",
                payload: "1"
            })
            dispatch({
                type: "interact-five9-reset",
                payload: ""
            })
            dispatch({
              type: "store-five9-details-reset",
              payload: ""
            })
            dispatch({
                type: "store-five9-clicktodial-reset",
                payload: ""
            })
            dispatch({
              type: "store-five9-user-state-reset",
              payload: ""
            })
            sessionStorage.removeItem("subjectid");
            sessionStorage.removeItem("sourceid");
            sessionStorage.removeItem("ani");
            sessionStorage.removeItem("dnis");
            sessionStorage.removeItem("agentName");
  
            sessionStorage.removeItem("five9_userid");
            
            sessionStorage.removeItem("five9_subject_id");
            sessionStorage.removeItem("five9_source_id");
            sessionStorage.removeItem("five9_globalsearch");
            sessionStorage.removeItem("five9_user_state");
            sessionStorage.removeItem("PatientName");

  
            setFive9Logout(false);
            setTimeout(()=> {
              window.location.reload();
            }, 1500)
          }
  
          
      }, function (error: any) {
          // reject handler
          //log.debug('Call variables error ', error);
          console.log('Five9 Logout', error);
        });
      } else if(status == 435){
        notification.config({
          placement: "topRight",
          top: 50,
          duration: 3
        });
        notification['error']({
          message: "You cannot Logout when you are in Active Call.",
          description: ""
        });
      }
    }, function (error: any) {
        // reject handler
        //log.debug('Call variables error ', error);
        console.log('Five9 Session Stop', error);
    });
    
}

  const menu = (
    <Menu onClick={callFive9Logout}>
      {
        five9LogoutCodes &&
        five9LogoutCodes?.logoutCodes &&
        five9LogoutCodes?.logoutCodes?.length > 0 &&
        five9LogoutCodes?.logoutCodes?.filter((e: any) => e.selectable === true)?.map((value: any, index: any) => (
        <Menu.Item key={value?.id}>
            {value?.name}
        </Menu.Item>
        ))
      }
    </Menu>
  );

useEffect(()=>{
  if(vonageInteractionId?.interactionId=='' && contact_center_type === 'vonage'){
    dispatch({
      type: "one-state-source/reset",
      payload: {}
     })
  }
  //global search hide before login for vonage
  if(localStorage.getItem('VonageGlobal')==='true'){
    dispatch({
      type: "store-vonage-user-state",
      payload: {userStates:true}
  });
  }
},[vonageInteractionId])
  const hasFive9Call = contact_center_type === 'five9' && five9InteractionId?.interactionId && five9InteractionId?.interactionId?.length > 0
  const hasVonageCall = contact_center_type === 'vonage' && vonageInteractionId?.interactionId && vonageInteractionId?.interactionId?.length > 0
  const hasCcpCall = contact_center_type === 'connect' && ccpConnectionData?.connectionId && ccpConnectionData?.connectionId?.length > 0
  const hasTwilioCall = contact_center_type === 'twilio' && paramTwilioAni&&paramTwilioAni?.length > 0
  const hasGenesysCall = contact_center_type === 'genesys' && genesysinteraction?.flowdata && genesysinteraction?.flowdata.id;
  const notactivecall = (patients?.values?.length > 0 ? true : false) || (source?.values?.length > 0 ? true : false) || (choosecaller?.number?.length > 0 ? true : false)
  const hasActiveCall = notactivecall || hasFive9Call || hasCcpCall ||hasVonageCall||hasTwilioCall|| hasGenesysCall || (contact_center_type !== 'five9' && contact_center_type !== 'connect' && contact_center_type !== 'wxcc' && contact_center_type !=='genesys' && contact_center_type !=='ringcentral' && consolidated_api_invocation!=='vonage' && hasGadgetCall)
  let five9Url = "";
  if(five9_sso_url === "" || five9_sso_url === undefined) {
    five9Url = five9_url;
  }
  else {
    five9Url = `${five9_url}${five9_sso_url}`
  }
  

  let updatepvornot = false;
  let pvarariable = updatepv?.usepv;
  if(pvarariable && pvarariable != "" ) {
    updatepvornot = true;
  }

 // Function to handle Intermedia Sessions API with advanced features
 const handleIntermediaSessionsApi = (searchparameter: any, token_intermedia: string) => {
  console.log('🔍 Starting Intermedia Sessions API with advanced features');
  console.log('Search parameter ANI:', searchparameter?.ani);
  console.log('Search parameter callid:', searchparameter?.callid);

  // API call to get sessions
  fetch(
    agentid_url_sessions,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'token': token_intermedia
      }
    }
  )
  .then(response => {
    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    return response.json();
  })
  .then(data => {
    console.log('Sessions API response:', data);
    
    // Process all sessions to find matching CallId
    if (data && Array.isArray(data)) {
      console.log('Sessions data received:', data);
      console.log('Number of sessions:', data.length);
      console.log('Search CallId from URL:', searchparameter?.callid);
      
      // Sort data array by StartDateUtc in descending order (latest first)
      data.sort((a: any, b: any) => {
        const dateA = new Date(a.StartDateUtc);
        const dateB = new Date(b.StartDateUtc);
        return dateB.getTime() - dateA.getTime(); // Descending order (latest first)
      });
      
      console.log('Sessions sorted by StartDateUtc (latest first):', data);
      
      // Process sessions with rate limiting and retry logic
      const processSessions = async () => {
        console.log(`Processing ${data.length} sessions with rate limiting...`);
        
        // Rate limiting configuration
        const RATE_LIMIT_DELAY = 100; // 100ms between calls
        const MAX_RETRIES = 3;
        const RETRY_DELAY = 1000; // 1 second between retries
        
        // Helper function to delay execution
        const delay = (ms: number) => new Promise(resolve => setTimeout(resolve, ms));
        
        // Helper function to make API call with retry logic
        const makeApiCallWithRetry = async (session: any, index: number, retryCount = 0) => {
          try {
            console.log(`API call ${retryCount + 1} for session ${index + 1}/${data.length}:`, session.SessionId);
            
            const response = await fetch(
              `${agentid_url_session}${session.SessionId}/interactions/voice`,
              {
                method: 'GET',
                headers: {
                  'Content-Type': 'application/json',
                  'token': token_intermedia
                }
              }
            );
            
            // Handle rate limiting (429 status)
            if (response.status === 429) {
              console.log(`Rate limited for session ${session.SessionId}. Retrying in ${RETRY_DELAY}ms...`);
              if (retryCount < MAX_RETRIES) {
                await delay(RETRY_DELAY);
                return makeApiCallWithRetry(session, index, retryCount + 1);
              } else {
                console.log(`Max retries reached for session ${session.SessionId}`);
                return null;
              }
            }
            
            if (!response.ok) {
              console.log(`Error fetching voice interactions for session ${session.SessionId}:`, response.status);
              return null;
            }
            
            const voiceData = await response.json();
            console.log(`Voice interactions for session ${session.SessionId}:`, voiceData);
            
            // Compare CallId from response with searchparameter?.callid
            if (voiceData && voiceData.CallId) {
              const callIdMatch = voiceData.CallId === searchparameter?.callid;
              console.log('CallId comparison:', {
                sessionId: session.SessionId,
                responseCallId: voiceData.CallId,
                searchParameterCallId: searchparameter?.callid,
                isMatch: callIdMatch
              });
              
              // If CallId matches, return success
              if (callIdMatch) {
                console.log('CallId match found! Using session:', session);
                return {
                  session: session,
                  voiceData: voiceData,
                  matched: true
                };
              }
            }
            
            return null;
          } catch (error) {
            console.error(`Error processing session ${session.SessionId}:`, error);
            if (retryCount < MAX_RETRIES) {
              console.log(`Retrying session ${session.SessionId} in ${RETRY_DELAY}ms...`);
              await delay(RETRY_DELAY);
              return makeApiCallWithRetry(session, index, retryCount + 1);
            }
            return null;
          }
        };
        
        // Process sessions sequentially with rate limiting
        for (let i = 0; i < data.length; i++) {
          const session = data[i];
          console.log(`Processing session ${i + 1}/${data.length} with rate limiting...`);
          
          // Add delay between API calls to respect rate limits
          if (i > 0) {
            console.log(`Waiting ${RATE_LIMIT_DELAY}ms before next API call...`);
            await delay(RATE_LIMIT_DELAY);
          }
          
          const result = await makeApiCallWithRetry(session, i);
          
          // If we found a match, stop processing
          if (result && result.matched) {
            console.log('Match found! Storing AgentId:', result.session.AgentId);
            if(intermedia_agentId === "username"){
              sessionStorage.setItem('intermedia_uid', result.session.Username);
            }
            else if(intermedia_agentId === "agentid"){
              sessionStorage.setItem('intermedia_uid', result.session.AgentId);
            }
            sessionStorage.setItem('intermedia_username', result.session.Username);
            console.log('AgentId stored successfully');
            return; // Exit early when match is found
          }
        }
        
        console.log('No CallId match found in any session');
      };
      
      // Execute the session processing
      processSessions();
    }
  })
  .catch(error => {
    console.error('Error fetching sessions:', error);
  });
};

  return (
    <Layout>
      <h1 style={{ position: "absolute", left: "-10000px", top: "auto", width: "1px", height: "1px", overflow: "hidden" }}>Patient Assist</h1>
      {(contact_center_type === 'five9' || contact_center_type === 'connect') && (
        <div
          className={contact_center_type === 'five9' ? 'float_five9' : 'float_connect'}
          style={{ display: widget ? 'block' : 'none' }}
        >
          {contact_center_type === 'five9' ? (
            <div><iframe
              src={five9Url}
              sandbox="allow-scripts allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-forms allow-downloads"
              allow="microphone; clipboard-read; clipboard-write"
              style={{ height: five9_Adapter_height, width: five9_Adapter_width }}
            ></iframe>
            {(contact_center_type &&
                    contact_center_type === 'five9' &&
                    five9Store &&
                    (five9Store?.globalsearch ||
                    sessionStorage.getItem("five9_globalsearch") === "true") && five9logout &&
                    (five9UserState?.userSates || sessionStorage.getItem("five9_user_state") === "true") && display_logout_button) && (
                <Popover placement="leftBottom" content={menu} trigger="click">
                  <Button style={{ paddingLeft: "27rem", backgroundColor: "#237ba9", marginLeft: "0.625rem" }}>
                    <span style={{ marginLeft: "-25rem", color: "white", fontSize: "medium" }}>Log Out </span>
                  </Button>
                </Popover>
                )}
            </div>
          ) : (
            <div id="containerDiv"></div>
          )}
        </div>
      )}
      <div role="navigation">
        <Header>
          <HeaderBar
            topnavigation={
              <>
                <TopNavigation>
                  <NavigationItem type="logo">
                    {(hasActiveCall) && (<img
                      src={Image_URL(resolver(logo), `${static_resource_url}logo.e26843c7.png`)}
                      alt={'SpinSci'}
                      draggable="false"
                      onClick={(e) => {
                        dispatch(setTabAction('1'));
                      }}
                      style={{cursor: 'pointer'}}
                      title="SpinSci"
                    />)}
                    {(!hasActiveCall) && (<img
                      src={Image_URL(resolver(logo), `${static_resource_url}logo.e26843c7.png`)}
                      alt={'SpinSci'}
                      draggable="false"
                      title="SpinSci"
                    />)}
                    {/* <UserIdCard 
                      model = {{epicuserdata : epicuserid}} 
                      className='nav-change-user-epic-btn'
                      style={{marginBottom: '0px', marginLeft: '5px'}}  
                    /> */}
                  </NavigationItem>
                  {/* <NavigationItem label="Total" value="78" /> */}
                </TopNavigation>
              </>
            }
            //btngroupnavigation={btngroupnavigation}
            usernavigation={
              <>
                <UserNavigation>
                {(contact_center_type &&
                      contact_center_type === 'five9' &&
                      five9Store &&
                      five9Store?.globalsearch &&
                      kill_all_notification) && (
                    <UserNavigationItem>
                      <Switch defaultChecked onChange={killNotification} />
                    </UserNavigationItem>
                  )}
                  <UserNavigationItem>
                    {((contact_center_type &&
                      contact_center_type === 'five9' &&
                      five9Store &&
                      (five9Store?.globalsearch ||
                      sessionStorage.getItem("five9_globalsearch") === "true") && five9logout) ||
                      (contact_center_type && contact_center_type === 'finesse') ||
                      (contact_center_type && contact_center_type === 'glia') ||
                      (contact_center_type && contact_center_type === 'connect')|| (contact_center_type && contact_center_type === 'wxcc') || (contact_center_type && contact_center_type === 'vonage' && vonageGlobalSearch) ||
                      (contact_center_type && contact_center_type === 'twilio') || (contact_center_type && contact_center_type === 'genesys')   || ((contact_center_type && contact_center_type === 'inContact') || ( contact_center_type && contact_center_type === 'ringcentral' && ringlogin) || (contact_center_type ==='intermedia'&& intermediasearch ) || (contact_center_type === 'glia') || (contact_center_type === 'ringcx'))) && (
                      <a
                        className="user-navigation__btn"
                        onClick={(e) => {
                          (search.patient || search.provider) && global_search();
                          dispatch(setPatientMatchFromAction(PatientMatchFrom.GLOBAL_SEARCH));
                        }}
                        href='javascript:void(0);'
                        aria-label="Search"
                      >
                        <Tooltip title="Search">
                          <img src={Image_URL(resolver(SearchIco), `${static_resource_url}search.c969bcf6.svg`)} width={17}  draggable="false" title="Search" alt="Search" aria-label="Search" />
                        </Tooltip>
                      </a>
                    )}
                    <PatientGlobalSearchCard
                      title="Search"
                      model={patientglobalsearch}
                      providermodel={providerglobalsearch}
                      onRowClick={(searchevent: any) => {
                        //Reset the error reducer
                        dispatch({
                          type:"one-state-error/reinit"
                        });
                        if (sourcesearchstate.show) {
                          let providersearchdata = patientglobalsearch?.data;
                          const sourceTypeForGlobalSearch: SourceType[] = soucetypelookup;
                          let indexval = providersearchdata.findIndex(
                            (prodetails: any) => prodetails.mrn === searchevent.mrn
                          );
                          let profound = false;

                          if (source?.values?.length > 0) {

                            let providersearchval = source?.values;
                            if (providersearchval && providersearchval.length > 0) {
                              providersearchval.forEach((providerdata: any) => {
                                if (providerdata?.id == searchevent?.mrn) {
                                  profound = true;
                                }
                              });
                            }
                          }

                          if (!profound) {
                            dispatch(addSourceAction(providersearchdata[indexval]));
                            if(patients?.values?.length ===0){
                            dispatch(addSubjectAction(providersearchdata[indexval]));
                            }
                          }

                          dispatch(setSourceType(sourceTypeForGlobalSearch));
                          dispatch(selectSourceType(sourceTypeForGlobalSearch[1]));
                          dispatch(reinitProviderSearchAction());
                          dispatch(reinitPatientSearchAction());
                          dispatch(globalSearchAction(false));
                          dispatch(selectAction(searchevent?.mrn));
                          dispatch({
                            type: 'one-state-choosecaller/set',
                            payload: {
                              number: choosecaller.number,
                              dnis: choosecaller.dnis,
                              visible: true,
                              start: false,
                              type: 'patient',
                            },
                          });
                          if(btgenable) {
                            dispatch({
                              type: "one-state-btgpatient/fetch",
                              payload: {
                                name: providersearchdata[indexval].lastname,
                                dob: providersearchdata[indexval].dob,
                                given: providersearchdata[indexval].firstname,
                                identifier: providersearchdata[indexval].id,
                                telecom: providersearchdata[indexval].contact
                              }
                            })
                          }
                          else{
                            if(getEHRProvider()==="epic"){
                            dispatch({
                              type: "one-state-btgpatient/fetch",
                              payload: {
                                identifier: providersearchdata[indexval].id,
                              }
                            })
                          }
                          }
                        } else {
                          // for disposition matching type

                          let disp: Disposition = { value: "" };
                          if (patientMatch.matchFrom === PatientMatchFrom.GLOBAL_SEARCH) {
                            dispatch(setPatientMatchTypeAction(PatientMatchType.GLOBAL_MATCH));
                            disp.value = '2004';
                            disp.meta00 = agentId;
                            disp.meta01 = teamName;
                            disp.meta02 = searchevent.mrn;
                            disp.meta03 = choosecaller?.number
                            disp.meta04 = "Verified through a Global Search"
                          } else {
                            if (patients?.values?.length > 0) { // mis match
                              dispatch(setPatientMatchTypeAction(PatientMatchType.MIS_MATCH));
                              disp.value = '2003';
                              disp.meta00 = agentId;
                              disp.meta01 = teamName;
                              disp.meta02 = searchevent.mrn;
                              disp.meta03 = choosecaller?.number
                              disp.meta04 = "Verified through a MisMatch"
                            } else { // no match
                              dispatch(setPatientMatchTypeAction(PatientMatchType.NO_MATCH));
                              disp.value = '2002';
                              disp.meta00 = agentId;
                              disp.meta01 = teamName;
                              disp.meta02 = searchevent.mrn;
                              disp.meta03 = choosecaller?.number
                              disp.meta04 = "Verified through a NoMatch"
                            }
                          }
                          dispatch({
                            type: "store-disposition-code",
                            payload: disp
                          });

                          let patientsearchdata = patientglobalsearch?.data;
                          let indexvalue = patientsearchdata.findIndex(
                            (pdetails: any) => pdetails.mrn === searchevent.mrn
                          );

                          let found = false;
                          if (patients?.values?.length > 0) {
                            let patientsearchval = patients?.values;
                            if (patientsearchval && patientsearchval.length > 0) {
                              patientsearchval.forEach((patientdata: any) => {
                                if (patientdata?.mrn == searchevent?.mrn) {
                                  found = true;
                                }
                              });
                            }
                          }

                          if (!found) {
                            dispatch(addSubjectAction(patientsearchdata[indexvalue]));
                          }
                          if(btgenable && sessionStorage.getItem('ehr')!=='cerner') {

                            if(epic){
                              sessionStorage.setItem("subjectid", patientsearchdata[indexvalue].id);
                              dispatch({
                                type: "one-state-btgpatient/fetch",
                                payload: {
                                  name: patientsearchdata[indexvalue].lastname,
                                  dob: patientsearchdata[indexvalue].dob,
                                  given: patientsearchdata[indexvalue].firstname,
                                  identifier: patientsearchdata[indexvalue].id,
                                  telecom: patientsearchdata[indexvalue].contact
                                }
                              })
                        if(patientsearchdata[indexvalue].id && (screenpop_type === 'receive_communication' || screenpop_type === 'receive_communication02' ) && autoscreenpop) {
                          let agentIdValue = agentId;let calldnisdata = choosecaller.dnis;
                          //To check for the contact center type and update the  agentIDValue
                            if (contact_center_type && contact_center_type === 'five9') {
                              //This is for Five9
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            if (contact_center_type && contact_center_type === 'vonage' ) {
                              //This is for Vonage
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            if (contact_center_type && contact_center_type === 'inContact' ) {
                              //This is for Vonage
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            if (contact_center_type && contact_center_type === 'twilio' ) {
                              //This is for Twilio
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            else if(contact_center_type === "genesys") {
                              //This is for Genesys
                              agentIdValue = genesysagentdata
                              calldnisdata = sessionStorage.getItem("genesys_dnis");
                            }
                            if (contact_center_type && contact_center_type === 'ringcentral' ) {
                              //This is for ring central
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            if (contact_center_type && contact_center_type === 'wxcc' ) {
                              //This is for Vonage
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            if (contact_center_type && contact_center_type === 'intermedia' ) {
                              //This is for Vonage
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
                            if (sso === false ) {
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            const patientId = patientsearchdata[indexvalue]?.id
                            const sobject: ReceiveCommModel = {
                              //The Context value is the screenpop key 
                              context: autoscreenpop_default_context,
                              // The selected patients ID
                              patientId: patientId ? patientId : "",
                              //AgentId is either the epicuserid or agentID based on the  sso value
                              agentId: agentIdValue,
                              //This value is  configurable (Example value: External)
                              useridtype: useridtype,
                              //This value is  configurable (Example value: Patient/None)
                              lookuptype: lookuptype,
                              // DNIS value
                              callId: calldnisdata,
                              //Type of Call
                              contactType: 'Incoming',
                              //Type of Communication
                              communicationType: 'Phone',
                              //ANI
                              phoneNumber: choosecaller?.number,
                              //PatientID Type
                              type: patientId ? searchID : "",
                            }
                          //Dispatching for Screenpop
                            dispatch(ReceiveCommAction(sobject));
                            //Dispostion Auto Screenpop
                            let disp: Disposition = { value: "2030" }
                            disp.dial_list_uid = interactionId;
                            disp.meta00 = agentIdValue;
                            disp.meta01 = teamName;
                            disp.meta02 = epicuserid?.agentuserid
                            disp.meta03 = autoscreenpop_default_context
                            disp.meta04 = patientsearchdata[indexvalue].id;
                            disp.meta05 = 'Auto Screenpop';
                            dispatch({
                              type: "store-disposition-code",
                              payload: disp
                            })
                        }
                        else if(patientsearchdata[indexvalue].id && (screenpop_type === 'receive_communication03' ) && autoscreenpop){
                          const sourceId = sessionStorage.getItem("sourceid");
                          let useragentid=""
                          let calldnisdata = choosecaller.dnis
                          // Storing the epicuserid id valiue initially as agentId
                          let agentIdValue = agentId;
                          //To check for the contact center type and update the  agentIDValue
                            if (contact_center_type && contact_center_type === 'five9') {
                              //This is for Five9
                              agentIdValue = sessionStorage.getItem("five9_userid");
                              useragentid=sourceId ? sourceId : null
                            }
                            else if (contact_center_type && contact_center_type === 'vonage' ) {
                              //This is for Vonage
                              agentIdValue = sessionStorage.getItem("vonage_userid")
                              useragentid=sessionStorage.getItem("vonageInteractionId")
                            }
                            else if (contact_center_type && contact_center_type === 'inContact' ) {
                              //This is for Vonage
                              agentIdValue = sessionStorage.getItem("NiceEpicUserID")
                              useragentid=sessionStorage.getItem("Incontact_uid")
                            }
                            else if (contact_center_type && contact_center_type === 'twilio' ) {
                              //This is for Twilio
                              agentIdValue = sessionStorage.getItem("twilio_userid")
                              useragentid=sessionStorage.getItem("twilio_uid")
                            }
                            else if (contact_center_type && contact_center_type === 'ringcentral' ) {
                              //This is for ringcentral
                              agentIdValue = sessionStorage.getItem("ringcentral_agentName")
                              useragentid=sessionStorage.getItem("rc_uid")
                            }
                            else if(contact_center_type === "genesys") {
                              //This is for Genesys
                              agentIdValue = genesysagentdata
                              calldnisdata = sessionStorage.getItem("genesys_dnis");
                              useragentid=sessionStorage.getItem("genesys_uid")
                            }
                            else if (contact_center_type && contact_center_type === 'wxcc' ) {
                              //This is for Vonage
                              agentIdValue = epicuserid?.agentuserid;
                              useragentid=wxccInteraction?.taskMap?.interactionId
                            }
                            else if (contact_center_type && contact_center_type === 'intermedia' ) {
                              //This is for Vonage
                              agentIdValue = sessionStorage.getItem("intermedia_userid")
                              useragentid=sessionStorage.getItem("intermedia_uid")
                            }
                            // If the SSO is configured as false in the configuration file then epicuserID is passed  as agentId else agentID is passed as agentId.
                            if (sso === false ) {
                              agentIdValue = epicuserid?.agentuserid;
                            }
                            const patientId = patients?.selected?.id
                            const sobject: ReceiveCommModel = {
                              //The Context value is the screenpop key 
                              context: autoscreenpop_default_context,
                              // The selected patients ID
                              patientId: patientId ? patientId : "",
                              //AgentId is either the epicuserid or agentID based on the  sso value
                              agentId: agentIdValue,
                              //This value is  configurable (Example value: External)
                              useridtype: useridtype,
                              //This value is  configurable (Example value: Patient/None)
                              lookuptype: lookuptype,
                              // DNIS value
                              callId: useragentid,
                              //Type of Call
                              contactType: 'Incoming',
                              //Type of Communication
                              communicationType: 'Phone',
                              //ANI
                              phoneNumber: choosecaller?.number,
                              //PatientID Type
                              type: patientId ? searchID : "",
                    
                              DialedPhoneNumber:calldnisdata,
                    
                            }
                            //Dispatching for Screenpop
                            dispatch(ReceiveCommAction(sobject));
                            //Dispostion Auto Screenpop
                            let disp: Disposition = { value: "2030" }
                            disp.dial_list_uid = interactionId;
                            disp.meta00 = agentIdValue;
                            disp.meta01 = teamName;
                            disp.meta02 = epicuserid?.agentuserid
                            disp.meta03 = autoscreenpop_default_context
                            disp.meta04 = patientId;
                            disp.meta05 = 'Auto Screenpop';
                            dispatch({
                              type: "store-disposition-code",
                              payload: disp
                            })
                        }                           // Storing the epicuserid id valiue initially as agentId
                            }
                            if (athena) {
                              globalSelectedPatient(patientsearchdata[indexvalue])
                            }
                            setGlobalPatientSelected(patientsearchdata[indexvalue]);
                          }
                          else {
                            if(getEHRProvider()==="epic"){
                            dispatch({
                              type: "one-state-btgpatient/fetch",
                              payload: {
                                identifier: patientsearchdata[indexvalue].id,
                              }
                            })
                          }
                            globalSelectedPatient(patientsearchdata[indexvalue])
                          }
                        }
                      }}
                      onProviderRowClick={(providersearchevent: any) => {
                        let providersearchdata = providerglobalsearch?.data;
                        const sourceTypeForGlobalSearch: SourceType[] = soucetypelookup;
                        let indexval = providersearchdata.findIndex(
                          (prodetails: any) => prodetails.id === providersearchevent
                        );
                        
                        // Remove any existing providers first to ensure clean replacement
                        if (source?.values?.length > 0) {
                          let providersearchval = source?.values;
                          if (providersearchval && providersearchval.length > 0) {
                            providersearchval.forEach((providerdata: any) => {
                              if (providerdata?.typename === "Provider") {
                                dispatch(removeAction(providerdata.id));
                              }
                            });
                          }
                        }
                        
                        // Add the new provider
                        const payload = {
                          ...providersearchdata[indexval],
                          contact_formatted: providersearchdata[indexval].contact
                        }
                        dispatch(addSourceAction(payload));

                        dispatch(setSourceType(sourceTypeForGlobalSearch));
                        dispatch(selectSourceType(sourceTypeForGlobalSearch[1]));
                        dispatch(reinitProviderSearchAction());
                        dispatch(globalSearchAction(false));
                        dispatch(selectAction(providersearchevent));
                      }}
                    />
                  </UserNavigationItem>
                  {!monitorvalue && (
                    <UserNavigationItem>
                      <a className="user-navigation__btn" href='javascript:void(0);' aria-label="error">
                        <ErrorHandlingCard />
                      </a>
                    </UserNavigationItem>
                  )}

                  {((contact_center_type &&
                      contact_center_type === 'five9' &&
                      five9Store &&
                      (five9Store?.globalsearch ||
                      sessionStorage.getItem("five9_globalsearch") === "true") && five9logout) ||
                      (contact_center_type && contact_center_type === 'finesse') ||
                      (contact_center_type && contact_center_type === 'glia') ||
                      (contact_center_type && contact_center_type === 'connect') 
                      || (contact_center_type && contact_center_type === 'wxcc') || (contact_center_type && contact_center_type === 'vonage')
                      ||(contact_center_type && contact_center_type === 'twilio') || (contact_center_type && contact_center_type === "genesys")  || (contact_center_type && contact_center_type === 'inContact'  || contact_center_type ==='ringcentral' || contact_center_type ==='intermedia' || contact_center_type === 'glia')) && (<UserNavigationItem>
                    {(getEHRProvider() === 'epic' ||getEHRProvider() === 'athena') && <a
                      className={`user-navigation__btn user-navigation__btn--box state--active`}
                      onClick={(e) => {
                        setQuickDrawer(true);
                      }}
                      aria-label="quick menu"
                      href='javascript:void(0);'
                      role="tooltip"
                    >
                      <Tooltip title="Quick Menu" placement="bottomRight">
                        <img src={Image_URL(resolver(NoteIco), `${static_resource_url}note.4b2bcf64.svg`)} width={17}  draggable="false" title="Quick Menu" alt="Quick Menu" aria-label="Quick Menu"/>
                      </Tooltip>
                    </a>}
                  </UserNavigationItem>
                  )}
                </UserNavigation>
              </>
            }
          />
          
        {getEHRProvider() === 'epic' || getEHRProvider() === 'athena'?
          <DrawerComp
            closable={true}
            width={'295px'}
            visible={quickdrawer}
            title="Quick Menu"
            onClose={(event1) => {
              setQuickDrawer(false);
            }}
          >
            <>
            {(screenpop_type === 'receive_communication' || screenpop_type === 'receive_communication02' || screenpop_type === 'receive_communication03') && (sessionStorage.getItem('ehr')==='epic') && (
              <>
                {/* Show UserIdCard for inContact only when SSO is false and paramIncontactEpicExternalID doesn't have value */}
                {contact_center_type === 'inContact' && sso === false && !paramInContactEpicExternalID && (
                  <UserIdCard
                  model = {{
                  epicuserdata : epicuserid
                  }}
                  />
                )}
                {/* Show UserIdCard for other contact center types */}
                {contact_center_type !== 'inContact' && (
                  <UserIdCard
                  model = {{
                  epicuserdata : epicuserid
                  }}
                  />
                )}
              </>
            )}
            
              <a
                className="ant-drawer__close"
                onClick={(e) => {
                  setQuickDrawer(false);
                }}
              >
                
                {' '}
                <img src={Image_URL(resolver(arrowRight), `${static_resource_url}arrow-right.9dade3ae.svg`)} width={6} height={10} style={{ fill: '#bdbdbd' }}  draggable="false"/>
              </a>
              {drawer?.screenpop  && <ScreenpopComp selected={patients.selected} ani={choosecaller?.number} dnis={choosecaller?.dnis}/>}
              {(drawer?.hotbuttons) && (contact_center_type === "finesse") && <HotButtons />}
              {(drawer?.hotbuttons) && (contact_center_type === "five9") && <HotButtonsFive9 />}
              <Divider/>
              {(panviva_user && !panviva_sso) &&(
              <PanvivaIdCard 
              model = {{
                panvivauserdata : panvivasearch
              }}
              />
            ) }
              {(hotlinks) && <PanvivaComp selected={patients.selected} ani={choosecaller?.number} dnis={choosecaller?.dnis} />}
            </>
          </DrawerComp>
          :null
          }
        </Header>
      </div>
      <Layout>
        {widget && sider && contact_center_type!=="twilio"&& (
          <Sider width={utility_menu_width} className="content-sider" />
        )}
        <Content>
          <ContentBox style={{maxWidth: uniphore ? '100%' : '124rem'}}>
            <NewVerifyFlow
              model={{
                source: source,
                subjects: patients.values,
                subjectselcted: patients?.selected,
                choosecaller: choosecaller,
              }}
              skeleton={skeleton}
            />
            {/* Remove PatientModalCard for ADPAC-489,ADPAC-490  */}
            {hasActiveCall && (
              <Row type="flex" gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}>
                  <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24} 
                       md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                       span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                  {/* Replace SourceCard for ADPAC-489,ADPAC-490 */}
                  <SourceCardSimple
                    title="Source"
                    source={source}
                    type={sourceType}
                    sourcePath={(source?.selected?.id === patients?.selected?.id || source?.selected?.id === subjectdemo?.id) ? 'patient' : ''}
                    gearActions={[
                      {
                        id: '1',
                        label: 'Add New Source',
                        onClick: () => {
                          dispatch(
                            addNewFormAction({
                              value: true,
                            })
                          );
                        },
                      },
                    ]}
                    onAddNewChange={(value: any) => {
                      dispatch(
                        addNewFormAction({
                          value: value,
                        })
                      );
                    }}
                    verifySource={() => {
                      if ((source?.values.length > 0 || source?.values?.length === 0) ||  source?.selected === undefined ) {
                        dispatch({
                          type: 'one-state-choosecaller/set',
                          payload: {
                            number: choosecaller.number,
                            dnis: choosecaller.dnis,
                            visible: true,
                            start: false,
                            type: 'provider',
                            clicked: true,
                          },
                        });
                      }
                    }}
                    skeleton={skeleton}
                    patientcount={patients?.values?.length}
                  />
                  <AddNewFormEnable value={addnew} choosecaller={choosecaller} />
                </Col>
                <Col sm={contact_center_type && contact_center_type === 'finesse' ? null : 24}
                     md={contact_center_type && contact_center_type === 'finesse' ? null : 12}
                     span={contact_center_type && contact_center_type === 'finesse' ? 12 : null}>
                  <SubjectCard
                    title="Subject"
                    gearActions={screenpop_config.screenpop_label && cardScreenpopData(screenpop_config_subjectcard)}
                    onPatientScreenpopChange={(value: any) => {
                      handleScreenPop(patientchart);
                    }}
                    model={{
                      subjects: patients.values,
                      selected: patients.selected,
                    }}
                    verified={verify?.verified}
                    onSubjectChange={(value) => {
                      let subjectCardOnChangeSkeleton: Skeleton = {
                        upcomingAppts_skeleton: true,
                        pendingReferrals_skeleton: true,
                        pendingBills_skeleton: true,
                        insurance_skeleton: true,
                        pendingCare_skeleton: true,
                        pharmacies_skeleton: true,
                        prescription_skeleton: true,
                      };

                      const selected = patients.values.find((patient: any) => patient.id === value);

                      if(epic){

                        dispatch(setSelectedAction(selected));
                      }
                      if(cerner){
                        dispatch(setSelectedCernerAction(selected));
                
                      }
                      dispatch(setSkeletonAction(subjectCardOnChangeSkeleton));
                    }}
                    onClick={() => {
                      if (patients?.values.length > 0) {
                        dispatch({
                          type: 'one-state-choosecaller/set',
                          payload: {
                            number: choosecaller.number,
                            dnis: choosecaller.dnis,
                            visible: true,
                            start: false,
                            type: 'patient',
                            clicked: true,
                          },
                        });
                      }
                    }}
                    skeleton={skeleton}
                    allergy={activeallergy}
                    activeprob={activeproblem}
                    pediatricage={dashboardtab?.pediatricage}
                  />
                </Col>
              </Row>
            )}
            {hasActiveCall && (
              
              <Row 
                type="flex" 
                gutter={[16, contact_center_type && contact_center_type === 'finesse' ? 32 : { xs: 16, sm: 16, md: 32 }]}
                className='call-dest--notes-history'
              >
                  {(getEHRProvider()=='epic' || getEHRProvider()=='cerner' || getEHRProvider()=='athena' || getEHRProvider()=='nextgen' || getEHRProvider()=='meditech')?
                   <>
                <Col span={12}>
                  <CallDestinationCard
                    title="Calling Destination"
                    note={entity.calltype}
                    model={{
                      callingdest: entity,
                    }}
                    onClick={() => {
                      dispatch(setTabAction('8'));
                    }}
                    skeleton={skeleton}
                  />
                </Col>
                <Col span={12}>
                  <NotesHistoryCard />
                </Col>
                </>:
                <>
                <Col span={24}>
                  <CallDestinationCard
                    title="Calling Destination"
                    note={entity.calltype}
                    model={{
                      callingdest: entity,
                    }}
                    onClick={() => {
                      dispatch(setTabAction('8'));
                    }}
                    skeleton={skeleton}
                  />
                </Col>
                </>
                  }
              </Row>
            )} 
            {dashboard}
            {epicsuserdata}
            <Button id = "panviva_button" style={{"display": 'none', color: '#20418A'}} onClick={handleClickOutsideButton} >
            <img id="footer-logo" src="https://spinsci.supportpoint.com/pv-upland-favicon.png" alt="Logo"/>
              Panviva</Button>
          </ContentBox>
        </Content>
      </Layout>
      <Footer>
        <Affix offsetBottom={0}>
          <FooterBox
            mainblock={
              <>
                {agenta_dashboard_icon && (
                  <Button
                    className="ant-btn--ghost"
                    ghost
                    onClick={() => {
                      setWidget(!widget);
                    }}
                  >
                    <img src={resolver(AgentIco)} width={14} height={18} style={{ marginRight: '8px' }} draggable="false" />
                    Agent Dashboard
                  </Button>
                )}

                {simulator && <CallSelection />}
                {/* //versioning for vonage */}

                {version && <Version versionWidth={ contact_center_type && contact_center_type === 'finesse' ? '1242px' : '1105px' } versionShow={(contact_center_type==='vonage'|| contact_center_type==='twilio' ||  contact_center_type === 'inContact' || contact_center_type ==='ringcentral' || contact_center_type ==='intermedia' )?false:true}/>}
              </>
            }
            sideblock={
              <>
                {/* <FooterAsideItem >
                  Tab 1
            </FooterAsideItem>
                <FooterAsideItem >
                  Tab 2
               </FooterAsideItem>*/}
                <FooterAsideItem>
                  {(source.values.length > 0 || patients.values) && (
                    <NotifyCard
                      title="notify"
                      model={{
                        errorobject: errorstate?.values,
                      }}
                    />
                  )}
                </FooterAsideItem>
              </>
            }
          />
        </Affix>
      </Footer>
    </Layout>
  );
};